<template>
    <div class="container feedback template-bg-gray comm-req-page">
        <!-- 404 UI -->
        <NotFound
        v-if="showNotFound"
        :community_id="community_id"
        />
        <!-- regular page UI -->
        <div class="row" v-else>
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec ">
                <div class="loop_container bg-transparent update-request-form-common">
                    <div class="card form-wrapper">
                        <div class="feedback_container feedback_newupdate">
                            <div class="row">
                                <div class="col-md-12 text-center" v-if="isShow">
                                    <img :src="logoURL" class="top-logo custom-logo" :alt="'Community Logo of '+ (community && community.content && community.content.parameter4 ? community.content.parameter4 : (community && community.name) || 'Community')">
                                </div>
                                <CustomSkeleton :is-visible="!isShow" />
                            </div>
                            <template v-if="isBeforeRequest && showFormFlag && isShow">
                                <div class="">
                                    <div class="tab-content" id="myTabContent">
                                        <div id="about-you" class="tab_inn" v-show="isFirstPage">
                                            <h1 id="main-header" class="template-title">Tell us a bit about yourself</h1>
                                            <p class="box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-if="community.content && community.content.requestIntroduction" v-html="community.content.requestIntroduction"></p>
                                            <p class=" box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-else >We need a little bit of information to match you to relevant experts in the community.</p>
                                            <form @submit.prevent="viewSecondPage('step-1')" data-vv-scope="step-1" class="template-form">
                                                <p class="required-note template-label" id="required-note">
                                                    Fields marked with an asterisk (<span class="required-symbol">*</span>) are required.
                                                </p>
                                                <div class="row responsive-v3-class">
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17 ">
                                                            <div class="input-group">
                                                                <label class="template-label" for="firstName">{{configureFields.firstName.labelName}}<span class="required-symbol"> *</span></label>
                                                                <input
                                                                type="text"
                                                                class="form-control input-value pt-input input-focus"
                                                                ref="firstName"
                                                                id="firstName"
                                                                v-model="ask.first"
                                                                name="first"
                                                                autocomplete="given-name"
                                                                placeholder=""
                                                                v-validate="'required'"
                                                                required
                                                                data-vv-validate-on="change"
                                                                aria-required="true"
                                                                aria-describedby="required-note"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-1.first') }"
                                                                @input="e => ask.first = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                    class="error"
                                                                    v-show="errors.has('step-1.first')"
                                                                >{{errors.first('step-1.first')}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17">
                                                            <div class="input-group">
                                                                <label for="lastName" class="template-label">{{configureFields.lastName.labelName}}<span class="required-symbol"> *</span></label>
                                                                <input
                                                                type="text"
                                                                id="lastName"
                                                                class="form-control input-value pt-input input-focus"
                                                                v-model="ask.last"
                                                                name="last"
                                                                autocomplete="family-name"
                                                                placeholder=""
                                                                required
                                                                v-validate="'required'"
                                                                data-vv-validate-on="change"
                                                                aria-required="true"
                                                                aria-describedby="required-note"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-1.last') }"
                                                                @input="e => ask.last = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                    class="error"
                                                                    v-show="errors.has('step-1.last')"
                                                                >{{errors.first('step-1.last')}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17">
                                                            <div class="input-group">
                                                                <label for="email" class="template-label">{{configureFields.emailAddress.labelName}}<span class="required-symbol"> *</span></label>
                                                                <input
                                                                type="email"
                                                                class="form-control input-value pt-input input-focus"
                                                                id="email"
                                                                autocomplete="email"
                                                                v-model="ask.email"
                                                                @change="checkMemberStatus"
                                                                name="email"
                                                                placeholder=""
                                                                data-vv-validate-on="change"
                                                                v-validate.continues="'required|email'"
                                                                required
                                                                aria-required="true"
                                                                aria-describedby="required-note"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-1.email') }"
                                                                @input="e => ask.email = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                    v-show="errors.has('step-1.email')"
                                                                    class="error"
                                                                    >
                                                                        {{ errors.first('step-1.email') }}
                                                                    </p>
                                                                </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.memberRole && configureFields.memberRole.include && configureFields.memberRole.include === true">
                                                            <div class="input-group">
                                                                <label for="memberRole" class="template-label">{{memberRole.labelName}} <span class="required-symbol" v-if="checkAndValidate1('memberRole')"> *</span></label>
                                                                <select
                                                                    data-vv-validate-on="change|blur"
                                                                    v-validate.continues="`${checkAndValidate1('memberRole')}`"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="dynamicFields.memberRole"
                                                                    name="memberRole"
                                                                    id="memberRole"
                                                                    :aria-required="checkAndValidate1('memberRole') ? 'true' : 'false'"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-1.memberRole') }"
                                                                    :aria-describedby="checkAndValidate1('memberRole') ? 'required-note' : null"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select role</option>
                                                                    <option v-for="role in memberRole.memberValue" :key="role" :value="role.trim()">{{role.trim()}}</option>
                                                                </select>
                                                                <p
                                                                    v-show="errors.has('step-1.memberRole')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.memberRole') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.phoneNumber && configureFields.phoneNumber.include && configureFields.phoneNumber.include === true">
                                                            <div class="row">
                                                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                                    <div class="input-group" >
                                                                    <label for="phoneNumber" class="template-label">{{configureFields.phoneNumber.labelName}} <span class="required-symbol" v-if="checkAndValidate1('phoneNumber')"> *</span></label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control input-value pt-input input-focus"
                                                                        id="phoneNumber"
                                                                        v-model="dynamicFields.phoneNumber"
                                                                        name="phoneNumber"
                                                                        data-vv-validate-on="change"
                                                                        :aria-required="checkAndValidate1('phoneNumber') ? 'true' : 'false'"
                                                                        v-validate.continues="`${checkAndValidate1('phoneNumber')}`"
                                                                        :aria-describedby="checkAndValidate1('phoneNumber') ? 'required-note' : null"
                                                                        v-bind:class="{'request-form-error-border': errors.has('step-1.phoneNumber') }"
                                                                        @input="e => dynamicFields.phoneNumber = sanitizeInput(e.target.value)"
                                                                        >
                                                                    <p
                                                                        v-show="errors.has('step-1.phoneNumber')"
                                                                        class="error"
                                                                    >{{ errors.first('step-1.phoneNumber') }}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.adviceArea && configureFields.adviceArea.include && configureFields.adviceArea.include === true">
                                                            <div class="input-group">
                                                                <label class="template-label" for="adviceArea">{{adviceArea.labelName}}<span class="required-symbol" v-if="checkAndValidate1('adviceArea')"> *</span></label>
                                                                <select
                                                                    data-vv-validate-on="change|blur"
                                                                    v-validate="`${checkAndValidate1('adviceArea')}`"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="dynamicFields.adviceArea"
                                                                    name="adviceArea"
                                                                    :aria-required="checkAndValidate1('adviceArea') ? 'true' : 'false'"
                                                                    id="adviceArea"
                                                                    :aria-describedby="checkAndValidate1('adviceArea') ? 'required-note' : null"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select Area</option>
                                                                    <option v-for="role in adviceArea.memberValue" :key="role" :value="role.trim()">{{role.trim()}}</option>
                                                                </select>
                                                                <p
                                                                    v-show="errors.has('step-1.adviceArea')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.adviceArea') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17" v-if="configureFields.linkedInProfile && configureFields.linkedInProfile.include && configureFields.linkedInProfile.include === true">
                                                            <div class="input-group">
                                                                <label for="linkedInProfile" class="template-label">{{configureFields.linkedInProfile.labelName}}<span class="required-symbol" v-if="checkAndValidate1('linkedInProfile')"> *</span></label>
                                                                <input type="text"
                                                                    :aria-required="checkAndValidate1('linkedInProfile') ? 'true' : 'false'"
                                                                    :aria-describedby="checkAndValidate1('linkedInProfile') ? 'required-note' : null"
                                                                    class="form-control input-value pt-input input-focus" v-model="dynamicFields.linkedInProfile" id="linkedInProfile" name="linkedInProfile" v-bind:class="{'request-form-error-border': errors.has('linkedInProfile') }" data-vv-validate-on="change" v-validate="{ required: configureFields.linkedInProfile.require == true ? true: false, regex: /^http(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?$/ }" @input="e => dynamicFields.linkedInProfile = sanitizeUrl(e.target.value)">
                                                                <p
                                                                    v-show="errors.has('step-1.linkedInProfile')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.linkedInProfile') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.college && configureFields.college.include && configureFields.college.include === true">
                                                            <div class="input-group">
                                                                <label for="college" class="template-label">{{configureFields.college.labelName}}<span class="required-symbol" v-if="checkAndValidate1('college')"> *</span></label>
                                                                <input
                                                                type="text"
                                                                class="form-control input-value pt-input input-focus"
                                                                id="college"
                                                                v-model="dynamicFields.college"
                                                                name="college"
                                                                data-vv-validate-on="change"
                                                                :aria-required="checkAndValidate1('college') ? 'true' : 'false'"
                                                                :aria-describedby="checkAndValidate1('college') ? 'required-note' : null"
                                                                v-validate.continues="`${checkAndValidate1('college')}`"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-1.college') }"
                                                                @input="e => dynamicFields.college = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                    v-show="errors.has('step-1.college')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.college') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.college2 && configureFields.college2.include && configureFields.college2.include === true">
                                                            <div class="input-group">
                                                                <label for="college2" class="template-label">{{configureFields.college2.labelName}}<span class="required-symbol" v-if="checkAndValidate1('college2')"> *</span></label>
                                                                <select
                                                                    id="college2"
                                                                    :aria-required="checkAndValidate1('college2') ? 'true' : 'false'"
                                                                    data-vv-validate-on="change|blur"
                                                                    :aria-describedby="checkAndValidate1('college2') ? 'required-note' : null"
                                                                    v-validate="`${checkAndValidate1('college2')}`"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="dynamicFields.college2"
                                                                    name="college2"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select {{configureFields.college2.labelName}}</option>
                                                                    <option v-for="(degree, idx) in college2.memberValue" :key="`college-${idx}`" :value="degree.trim()">{{degree.trim()}}</option>
                                                                </select>
                                                                <p
                                                                    v-show="errors.has('step-1.college2')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.college2') }}</p>
                                                            </div>
                                                        </div>
                                                        <!-- Major (Dropdown - multi select via chips) -->
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.major && configureFields.major.include && configureFields.major.include === true">
                                                            <div class="input-group">
                                                                <label for="major" class="template-label">{{configureFields.major.labelName}}<span class="required-symbol" v-if="checkAndValidate1('major')"> *</span></label>
                                                                <select
                                                                    id="major"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="selectedMajorTemp"
                                                                    name="majorSelect"
                                                                    :aria-required="checkAndValidate1('major') ? 'true' : 'false'"
                                                                    data-vv-validate-on="change|blur"
                                                                    @change="onMajorSelect"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select {{configureFields.major.labelName}}</option>
                                                                    <option v-for="(m, idx) in major.memberValue" :key="`major-${idx}`" :value="m.trim()">{{m.trim()}}</option>
                                                                </select>

                                                                <input type="hidden" name="major" :value="majorJoined" v-validate="`${checkAndValidate1('major')}`" data-vv-validate-on="change|blur" :aria-describedby="checkAndValidate1('major') ? 'required-note' : null" />
                                                                <p v-show="errors.has('step-1.major')" class="error">{{ errors.first('step-1.major') }}</p>
                                                                <!-- Major limit message removed per request -->
                                                                <div v-if="dynamicFields.major && dynamicFields.major.length" class="selected-chips">
                                                                      <span v-for="m in dynamicFields.major" :key="`major-chip-${m}`" class="chip">{{ m }}
                                                                          <button type="button" class="chip-close" :aria-label="'Remove ' + m" @click.stop="removeMajorByValue(m)">×</button>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.classYear && configureFields.classYear.include && configureFields.classYear.include === true">
                                                            <div class="input-group">
                                                                <label for="year" class="template-label">{{configureFields.classYear.labelName}}<span class="required-symbol" v-if="checkAndValidate1('year')"> *</span></label>
                                                                <input
                                                                type="text"
                                                                class="form-control input-value pt-input input-focus"
                                                                id="year"
                                                                v-model="dynamicFields.year"
                                                                :aria-describedby="checkAndValidate1('year') ? 'required-note' : null"
                                                                name="year"
                                                                :aria-required="checkAndValidate1('year') ? 'true' : 'false'"
                                                                data-vv-validate-on="change"
                                                                v-validate.continues="`${checkAndValidate1('year')}`"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-1.year') }"
                                                                @input="e => dynamicFields.year = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                    v-show="errors.has('step-1.year')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.year') }}</p>
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.classYear2 && configureFields.classYear2.include && configureFields.classYear2.include === true">
                                                            <div class="input-group">
                                                                <label for="year2" class="template-label">{{configureFields.classYear2.labelName}}<span class="required-symbol" v-if="checkAndValidate1('year2')"> *</span></label>
                                                                <select
                                                                    id="year2"
                                                                    data-vv-validate-on="change|blur"
                                                                    v-validate="`${checkAndValidate1('year2')}`"
                                                                    :aria-required="checkAndValidate1('year2') ? 'true' : 'false'"
                                                                    :aria-describedby="checkAndValidate1('year2') ? 'required-note' : null"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="dynamicFields.year2"
                                                                    name="year2"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select {{configureFields.classYear2.labelName}}</option>
                                                                    <option v-for="(year,idx) in classYear2.memberValue" :key="`year-${idx}`" :value="year.trim()">{{year.trim()}}</option>
                                                                </select>
                                                                <p
                                                                    v-show="errors.has('step-1.year2')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.year2') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.organization && configureFields.organization.include && configureFields.organization.include === true">
                                                            <div class="input-group">
                                                                <label for="organization" class="template-label">{{configureFields.organization.labelName}}<span class="required-symbol" v-if="checkAndValidate1('organization')"> *</span></label>
                                                                <input
                                                                type="text"
                                                                class="form-control input-value pt-input input-focus"
                                                                id="organization"
                                                                v-model="dynamicFields.organization"
                                                                :aria-required="checkAndValidate1('organization') ? 'true' : 'false'"
                                                                name="organization"
                                                                :aria-describedby="checkAndValidate1('organization') ? 'required-note' : null"
                                                                data-vv-validate-on="change"
                                                                v-validate.continues="`${checkAndValidate1('organization')}`"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-1.organization') }"
                                                                @input="e => dynamicFields.organization = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                    v-show="errors.has('step-1.organization')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.organization') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.title && configureFields.title.include && configureFields.title.include === true">
                                                            <div class="input-group">
                                                                <label for="role" class="template-label">{{configureFields.title.labelName}}<span class="required-symbol" v-if="checkAndValidate1('role')"> *</span></label>
                                                                <input
                                                                type="text"
                                                                class="form-control input-value pt-input input-focus"
                                                                v-model="dynamicFields.role"
                                                                id="role"
                                                                :aria-required="checkAndValidate1('role') ? 'true' : 'false'"
                                                                name="role"
                                                                :aria-describedby="checkAndValidate1('role') ? 'required-note' : null"
                                                                data-vv-validate-on="change"
                                                                v-validate.continues="`${checkAndValidate1('role')}`"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-1.role') }"
                                                                @input="e => dynamicFields.role = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                    v-show="errors.has('step-1.role')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.role') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.studentId && configureFields.studentId.include && configureFields.studentId.include === true">
                                                            <div class="input-group">
                                                                <label for="studentId" class="template-label">{{configureFields.studentId.labelName}}<span class="required-symbol" v-if="checkAndValidate1('studentId')"> *</span></label>
                                                                <input
                                                                type="text"
                                                                class="form-control input-value pt-input input-focus"
                                                                v-model="dynamicFields.studentId"
                                                                id="studentId"
                                                                :aria-required="checkAndValidate1('studentId') ? 'true' : 'false'"
                                                                name="studentId"
                                                                :aria-describedby="checkAndValidate1('studentId') ? 'required-note' : null"
                                                                data-vv-validate-on="change"
                                                                v-validate.continues="`${checkAndValidate1('studentId')}`"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-1.studentId') }"
                                                                @input="e => dynamicFields.studentId = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                    v-show="errors.has('step-1.studentId')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.studentId') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17" v-if="configureFields.dueDate && configureFields.dueDate.include && configureFields.dueDate.include === true">
                                                            <div class="input-group">
                                                                <label for="dueDate" class="template-label">{{configureFields.dueDate.labelName}}<span class="required-symbol" v-if="checkAndValidate1('dueDate')"> *</span></label>
                                                                <datepicker id="dueDate" name="dueDate" class="input-focus template-input-date-picker" :aria-required="checkAndValidate1('dueDate') ? 'true' : 'false'" :aria-describedby="checkAndValidate1('dueDate') ? 'required-note' : null" v-model="dynamicFields.dueDate" v-bind:class="{'request-form-error-border': errors.has('step-1.dueDate') }"  :format="DatePickerFormat" :disabledDates="disabledDates" data-vv-validate-on="change|blur" v-validate.continues="`${checkAndValidate1('dueDate')}`"></datepicker>
                                                                <p class="helper-text template-label mb-0-custom"><strong>Note:</strong> Does your request have an expiration date after which an answer is no longer desirable?</p>
                                                                <p
                                                                    v-show="errors.has('step-1.dueDate')"
                                                                    class="error"
                                                                >{{ errors.first('step-1.dueDate') }}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17" v-if="configureFields.referrer && configureFields.referrer.include && configureFields.referrer.include === true">
                                                            <div class="input-group">
                                                                <label for="referrer" class="template-label">{{configureFields.referrer.labelName}}<span class="required-symbol" v-if="checkAndValidate1('referrer')"> *</span></label>
                                                                <input
                                                                type="text"
                                                                id="referrer"
                                                                class="form-control input-value pt-input input-focus"
                                                                v-model="dynamicFields.referrer"
                                                                :aria-required="checkAndValidate1('referrer') ? 'true' : 'false'"
                                                                name="referrer"
                                                                placeholder=""
                                                                :aria-describedby="checkAndValidate1('referrer') ? 'required-note' : null"
                                                                v-validate.continues="`${checkAndValidate1('referrer')}`"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-1.referrer') }"
                                                                data-vv-validate-on="change"
                                                                @input="e => dynamicFields.referrer = sanitizeInput(e.target.value)"
                                                                >
                                                                <p
                                                                    class="error"
                                                                    v-show="errors.has('step-1.referrer')"
                                                                >{{errors.first('step-1.referrer')}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-17" v-if="configureFields.referrer2 && configureFields.referrer2.include && configureFields.referrer2.include === true">
                                                            <div class="input-group">
                                                                <label for="referrer2" class="template-label">{{configureFields.referrer2.labelName}}<span class="required-symbol" v-if="checkAndValidate1('referrer2')"> *</span></label>
                                                                <select
                                                                    id="referrer2"
                                                                    data-vv-validate-on="change|blur"
                                                                    v-validate="`${checkAndValidate1('referrer2')}`"
                                                                    :aria-describedby="checkAndValidate1('referrer2') ? 'required-note' : null"
                                                                    class="form-control template-drop-down input-value pt-input input-focus select-dropdown requestPageDropdown"
                                                                    v-model="dynamicFields.referrer2"
                                                                    :aria-required="checkAndValidate1('referrer2') ? 'true' : 'false'"
                                                                    name="referrer2"
                                                                >
                                                                    <option value="" selected disabled style="display:none">Select</option>
                                                                    <option v-for="(degree, idx) in referrer2.memberValue" :key="`referrer-${idx}`" :value="degree.trim()">{{degree.trim()}}</option>
                                                                </select>
                                                                <p
                                                                v-show="errors.has('step-1.referrer2')"
                                                                class="error"
                                                                >{{ errors.first('step-1.referrer2') }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="template-mb-35" v-if="configureFields.disclaimer && configureFields.dueDate.include === false"></div>
                                                    <div
                                                        class="responsive-v3-class"
                                                        style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap;"
                                                        >
                                                        <div class="button-container" style="margin-left: auto;">
                                                            <md-button
                                                            type="submit"
                                                            :style="styleSubmitBtn"
                                                            class="btn_info template-review-submit template-button"
                                                            @click="onClick"
                                                            >
                                                            Next
                                                            </md-button>
                                                        </div>
                                                        </div>
                                                </form>
                                        </div>
                                        <div id="your-question" class="tab_inn" v-if="isSecondPage">
                                            <h1 class="template-title">What do you need help with?</h1>
                                            <p class=" box-sub-heading mb35 custom-content request-form-title-anchor-tab"  v-if="community.content && community.content.requestFormWizardPage2" v-html="community.content.requestFormWizardPage2"></p>
                                            <p class=" box-sub-heading mb35 custom-content request-form-title-anchor-tab" aria-live="polite" v-else>A great question will get you great answers (and connections). Here's a <a href="https://storage.googleapis.com/protopia/images/How%20to%20ask%20a%20question.mp4" target="_blank">Short video on how to craft one.</a></p>
                                            <form @submit.prevent="viewThirdPage('step-2')" data-vv-scope="step-2" class="template-form">
                                                <div class="row">
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17 magic-wand-field-col" :style="magicWandThemeStyle">
                                                            <div class="input-group">
                                                                <label for="title"  class="template-label" id="label-short-headline">
                                                                    Short headline <span class="required-symbol"> *</span>:
                                                                    <Tooltip aria-live="polite" :isInteractive="true" content="No more than three to four keywords that summarize the request and catch the reader's attention. For example: 'Consulting career' or 'Moving to Japan'." />
                                                                    <p class="sr-only" id="headline-description">Short headline tooltip: No more than three to four keywords that summarize the request and catch the reader's attention. For example: 'Consulting career' or 'Moving to Japan'.</p>
                                                                </label>
                                                                <div
                                                                    class="error-message error-for-textarea"
                                                                    v-show="errors.has('step-2.title')"
                                                                >{{errors.first('step-2.title')}}</div>
                                                                <div class="char-counter-input">
                                                                    <span id="char-counter-headline" aria-live="polite">{{subjectCount}} / {{ subjectMax }}<span class="sr-only"> character count </span></span>
                                                                </div>
                                                                <div class="magic-wand-field-input magic-wand-icon">
                                                                    <input
                                                                    ref="subjectMagicWand"
                                                                    tabindex="0"
                                                                    type="text"
                                                                    aria-labelledby="label-short-headline char-counter-headline"
                                                                    aria-describedby="char-counter-headline"
                                                                    class="form-control input-value input-focus pr16"
                                                                    id="title"
                                                                    v-model.trim="ask.subject"
                                                                    name="title"
                                                                    required
                                                                    aria-required="true"
                                                                    :maxlength="subjectMax"
                                                                    v-on:keyup="countdown('subject')"
                                                                    data-vv-validate-on="change|blur|input"
                                                                    v-validate="'required|min:10|max:100'"
                                                                    @keydown.enter="moveToNextTooltip"
                                                                    v-bind:class="{'request-form-error-border': errors.has('step-2.title') }"
                                                                    @focus="handleFocusChange($event)"
                                                                    @input="e => ask.subject = sanitizeInput(e.target.value)"
                                                                    >
                                                                    <a v-if="enableMagicWandLF"
                                                                        role="button"
                                                                        aria-label="View Examples"
                                                                        href="javascript:void(0);"
                                                                        @click.prevent="toggleMagicWandExamples('subject')"
                                                                        class="magic-wand-link-lw magic-wand-link-accent"
                                                                        :class="{'magic-wand-link-active': isExamplesOpen('subject')}"
                                                                    > View Examples
                                                                        <img :src="magicWandIcon" class="magic-wand-img magic-wand-img-panel" alt="" width="20" height="20">
                                                                    </a>
                                                                </div>
                                                            </div>
                                                            <div v-if="enableMagicWandLF && isExamplesOpen('subject')" class="magic-wand-examples-anchor">
                                                                <MagicWandExamplesPanel
                                                                    :examples="getWizardExamplesForField('subject')"
                                                                    :field-label="getMagicWandFieldLabel('subject')"
                                                                    :loading="wizardExamplesLoading"
                                                                    :magic-wand-icon="magicWandIcon"
                                                                    :accent-color="magicWandAccentColor"
                                                                    :field-has-text="magicWandFieldHasText('subject')"
                                                                    @close="closeMagicWandExamples"
                                                                    @use-example="insertMagicWandExample('subject', $event)"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17 magic-wand-field-col" :style="magicWandThemeStyle">
                                                            <div class="input-group template-input-text-area template-textarea-v3-t1 magic-wand-icon">
                                                                <label for="bio" class="template-label" id="label-brief-intro">
                                                                    Briefly introduce yourself <span class="required-symbol"> *</span>:
                                                                    <Tooltip aria-live="polite" :isInteractive="true" content="One or two sentences on who you are and that you are a part of the community. For example: I'm a rising junior majoring in [major] at [school]." />
                                                                    <p class="sr-only" id="introduction-description">Briefly introduce yourself tooltip: One or two sentences on who you are and that you are a part of the community. For example: I'm a rising junior majoring in [major] at [school].</p>
                                                                </label>
                                                                <div
                                                                    class="error-message-textarea error-for-textarea"
                                                                    v-show="errors.has('step-2.bio')"
                                                                >{{errors.first('step-2.bio')}}</div>
                                                                <div class="char-counter-input">
                                                                    <span id="char-counter-introduction" aria-live="polite">{{bioCount}} / {{ bioMax }}<span class="sr-only"> character count </span></span>
                                                                </div>
                                                                <textarea
                                                                aria-labelledby="label-brief-intro char-counter-introduction"
                                                                aria-describedby="char-counter-introduction"
                                                                ref="bioMagicWand"
                                                                class="form-control pt-input field_1"
                                                                id="bio"
                                                                v-model.trim="ask.bio"
                                                                name="bio"
                                                                required
                                                                aria-required="true"
                                                                v-on:keyup="countdown('bio')"
                                                                :maxlength="bioMax"
                                                                data-vv-validate-on="change|blur|input"
                                                                v-validate.continues="'required|max:500|min:100'"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-2.bio') }"
                                                                rows="3"
                                                                @input="e => ask.bio = sanitizeInput(e.target.value)"
                                                                @focus="handleFocusChange($event)"
                                                                ></textarea>
                                                                <a v-if="enableMagicWandLF"
                                                                    role="button"
                                                                    aria-label="View Examples"
                                                                    href="javascript:void(0);"
                                                                    @click.prevent="toggleMagicWandExamples('bio')"
                                                                    class="magic-wand-link-textarea-lw magic-wand-link-accent"
                                                                    :class="{'magic-wand-link-active': isExamplesOpen('bio')}"
                                                                > View Examples
                                                                    <img :src="magicWandIcon" class="magic-wand-img magic-wand-img-panel" alt="" width="20" height="20">
                                                                </a>
                                                            </div>
                                                            <div v-if="enableMagicWandLF && isExamplesOpen('bio')" class="magic-wand-examples-anchor">
                                                                <MagicWandExamplesPanel
                                                                    :examples="getWizardExamplesForField('bio')"
                                                                    :field-label="getMagicWandFieldLabel('bio')"
                                                                    :loading="wizardExamplesLoading"
                                                                    :magic-wand-icon="magicWandIcon"
                                                                    :accent-color="magicWandAccentColor"
                                                                    :field-has-text="magicWandFieldHasText('bio')"
                                                                    @close="closeMagicWandExamples"
                                                                    @use-example="insertMagicWandExample('bio', $event)"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17 magic-wand-field-col" :style="magicWandThemeStyle">
                                                            <div class="input-group template-input-text-area template-textarea-v3-t2 magic-wand-icon">
                                                                <label for="message" class="template-label" aria-label="What do you need help with?." >What do you need help with? <span class="required-symbol"> *</span>:
                                                                    <Tooltip aria-live="polite" :isInteractive="true" content="Make sure to 1) make it very clear WHAT you need help with, 2) WHY you want advice / guidance and 3) explain HOW help will make a difference. Keep it at no more than 2 paragraphs so that it’s easy to determine for the reader if she can assist. Great questions are clear, brief and personal." />
                                                                    <p class="sr-only" id="help-description">What do you need help with? tooltip: Make sure to 1.- make it very clear WHAT you need help with, 2.- WHY you want advice / guidance and 3.- explain HOW help will make a difference. Keep it at no more than 2 paragraphs so that it’s easy to determine for the reader if she can assist. Great questions are clear, brief and personal.</p>
                                                                </label>
                                                                <div
                                                                    class="error-message-textarea error-for-textarea"
                                                                    v-show="errors.has('step-2.message')"
                                                                >{{errors.first('step-2.message')}}</div>
                                                                <div class="char-counter-input">
                                                                    <span id="char-counter-help" aria-live="polite">{{textCount}} / {{textMax}}<span class="sr-only"> character count </span></span>
                                                                </div>
                                                                <textarea
                                                                ref="textMagicWand"
                                                                class="form-control pt-input field_2 "
                                                                id="message"
                                                                aria-label="What do you need help with? textarea, character count available"
                                                                aria-describedby="char-counter-help"
                                                                v-model.trim="ask.text"
                                                                name="message"
                                                                required
                                                                aria-required="true"
                                                                v-on:keyup="countdown('text')"
                                                                :maxlength="textMax"
                                                                data-vv-validate-on="change|blur|input"
                                                                v-validate.continues="'required|max:2000|min:250'"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-2.message') }"
                                                                rows="7"
                                                                @input="e => ask.text = sanitizeInput(e.target.value)"
                                                                @focus="handleFocusChange($event)"
                                                                ></textarea>
                                                                <a v-if="enableMagicWandLF"
                                                                    role="button"
                                                                    aria-label="View Examples"
                                                                    href="javascript:void(0);"
                                                                    @click.prevent="toggleMagicWandExamples('text')"
                                                                    class="magic-wand-link-textarea-lw magic-wand-link-accent"
                                                                    :class="{'magic-wand-link-active': isExamplesOpen('text')}"
                                                                > View Examples
                                                                    <img :src="magicWandIcon" class="magic-wand-img magic-wand-img-panel" alt="" width="20" height="20">
                                                                </a>
                                                            </div>
                                                            <div v-if="enableMagicWandLF && isExamplesOpen('text')" class="magic-wand-examples-anchor">
                                                                <MagicWandExamplesPanel
                                                                    :examples="getWizardExamplesForField('text')"
                                                                    :field-label="getMagicWandFieldLabel('text')"
                                                                    :loading="wizardExamplesLoading"
                                                                    :magic-wand-icon="magicWandIcon"
                                                                    :accent-color="magicWandAccentColor"
                                                                    :field-has-text="magicWandFieldHasText('text')"
                                                                    @close="closeMagicWandExamples"
                                                                    @use-example="insertMagicWandExample('text', $event)"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-17 magic-wand-field-col" :style="magicWandThemeStyle">
                                                            <div class="input-group template-input-text-area template-textarea-v3-t3 magic-wand-icon">
                                                                <label for="closeNicely" class="template-label" aria-label="Close nicely." >Close nicely <span class="required-symbol"> *</span>:
                                                                    <Tooltip aria-live="polite" :isInteractive="true" content="Tell the reader that you appreciate their time and help. Example: 'Thank you very much for your insights." />
                                                                    <p class="sr-only" id="closing-description">Close nicely tooltip: Tell the reader that you appreciate their time and help. Example: 'Thank you very much for your insights.</p>
                                                                </label>
                                                                <div
                                                                    class="error-message-textarea error-for-textarea"
                                                                    v-show="errors.has('step-2.closeNicely')"
                                                                >{{errors.first('step-2.closeNicely')}}</div>
                                                                <div class="char-counter-input">
                                                                    <span id="char-counter-closeNicely" aria-live="polite">{{closeNicelyCount}} / {{closeNicelyMax}} <span class="sr-only"> character count </span></span>
                                                                </div>
                                                                <textarea
                                                                aria-label="Close nicely textarea, character count available"
                                                                aria-describedby="char-counter-closeNicely"
                                                                ref="closeNicelyMagicWand"
                                                                class="form-control pt-input field_1"
                                                                id="closeNicely"
                                                                required
                                                                aria-required="true"
                                                                v-model.trim="ask.closeNicely"
                                                                v-on:keyup="countdown('closeNicely')"
                                                                name="closeNicely"
                                                                :maxlength="closeNicelyMax"
                                                                data-vv-validate-on="change|blur|input"
                                                                v-validate.continues="'required|max:500|min:5'"
                                                                v-bind:class="{'request-form-error-border': errors.has('step-2.closeNicely') }"
                                                                rows="3"
                                                                @focus="handleFocusChange($event)"
                                                                @input="e => ask.closeNicely = sanitizeInput(e.target.value)"
                                                                ></textarea>
                                                                <a v-if="enableMagicWandLF"
                                                                    role="button"
                                                                    aria-label="View Examples"
                                                                    href="javascript:void(0);"
                                                                    @click.prevent="toggleMagicWandExamples('closeNicely')"
                                                                    class="magic-wand-link-textarea-lw magic-wand-link-accent"
                                                                    :class="{'magic-wand-link-active': isExamplesOpen('closeNicely')}"
                                                                > View Examples
                                                                    <img :src="magicWandIcon" class="magic-wand-img magic-wand-img-panel" alt="" width="20" height="20">
                                                                </a>
                                                            </div>
                                                            <div v-if="enableMagicWandLF && isExamplesOpen('closeNicely')" class="magic-wand-examples-anchor">
                                                                <MagicWandExamplesPanel
                                                                    :examples="getWizardExamplesForField('closeNicely')"
                                                                    :field-label="getMagicWandFieldLabel('closeNicely')"
                                                                    :loading="wizardExamplesLoading"
                                                                    :magic-wand-icon="magicWandIcon"
                                                                    :accent-color="magicWandAccentColor"
                                                                    :field-has-text="magicWandFieldHasText('closeNicely')"
                                                                    @close="closeMagicWandExamples"
                                                                    @use-example="insertMagicWandExample('closeNicely', $event)"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mlr0" v-if="configureFields.disclaimer && configureFields.disclaimer.include && configureFields.disclaimer.include === true">
                                                        <div class="form-group disclaimer">
                                                            <md-checkbox
                                                                tabindex="1"
                                                                name="disclaimer"
                                                                id="disclaimer"
                                                                v-model="dynamicFields.disclaimer"
                                                                @change="updateDisclaimer()"
                                                                class="form-control template-checkbox pt-0"
                                                                :aria-required="checkAndValidate1('disclaimer') ? 'true' : 'false'"
                                                                data-vv-validate-on="change"
                                                                v-validate.continues="`${checkAndValidate1('disclaimer')}`"
                                                                >
                                                                {{ configureFields.disclaimer.labelName }}
                                                                <span class="required-symbol" v-if="checkAndValidate1('disclaimer')"> *</span>
                                                            </md-checkbox>
                                                            <p
                                                                v-show="errors.has('step-2.disclaimer')"
                                                                class="error error-mt-2 template-checkbox-error"
                                                            >{{ errors.first('step-2.disclaimer') }}</p>
                                                        </div>
                                                    </div>
                                                    <div class="template-mb-35" v-if="configureFields.disclaimer && configureFields.disclaimer.include === false"></div>
                                                    <div class="btn-block">
                                                        <div class="row back-next-step-2 pl-15 pr-15">
                                                            <div class="text-center-xs float-left">
                                                                <button
                                                                    :style="styleEditBtn"
                                                                    class="btn btn_info template-review-edit template-button mb-10"
                                                                    @click="goToFirst()"
                                                                    role="button"
                                                                >Back</button>
                                                            </div>
                                                                <div class="text-center-xs float-right">
                                                                <md-button type="submit" :style="styleSubmitBtn" class="btn btn_info template-review-submit template-button">Next</md-button>
                                                                <!-- <a href="javaScript:void(0)" :style="styleSubmitBtn" class="btn_info" @click="viewThirdPage()">Next</a> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                            </form>
                                        </div>
                                        <div class='tab_inn' v-if="isThirdPage && configureFields.interest && configureFields.interest.include">
                                            <h1 id="interests-header" class="template-title" >Choose 3-5 interests you have.</h1>
                                            <p class="box-sub-heading mb35 custom-content interest-description-display">{{configureFields.interest.description}}</p>
                                            <fieldset>
                                                <legend class="sr-only">Select your interests</legend>
                                            <div class="row text-center interest-container">
                                                <div
                                                    v-for="randomInterestItem in randomInterest"
                                                    :key="randomInterestItem"
                                                    class="col-md-4 col-sm-4 col-xs-6 width100"
                                                    ref="checkboxMainRef"
                                                >
                                                        <md-checkbox
                                                            class="my-round-checkbox"
                                                            :key="randomInterestItem"
                                                            v-model="selectedInterestList"
                                                            :value="randomInterestItem"
                                                            :name="randomInterestItem"
                                                            @change="updateAriaChecked(randomInterestItem)"
                                                            :aria-describedby="`interest-desc-${randomInterestItem.replace(/\s+/g, '-').toLowerCase()}`"
                                                        >
                                                            <span :id="`interest-desc-${randomInterestItem.replace(/\s+/g, '-').toLowerCase()}`">{{randomInterestItem}}</span>
                                                        </md-checkbox>
                                                    </div>
                                            </div>
                                            </fieldset>
                                            <div class="row back-next-step-2 pr-25 pl-25">
                                                <div class="text-center-xs float-left">
                                                  <button
                                                        tabindex="0"
                                                        class="btn btn_info template-review-edit template-button mb-10"
                                                        :style="styleEditBtn"
                                                        @click="goToSecond()"
                                                        role="button">Back
                                                  </button>
                                                </div>
                                                <div class="text-center-xs float-right">
                                                    <md-button type="submit"
                                                        :disabled="loading"
                                                        aria-label="Next: We're crafting a thoughtful question to present to your advisor. Clickable"
                                                        :aria-busy="loading"
                                                        @click="goToFourth()"
                                                        role="button"
                                                        :style="styleSubmitBtn"
                                                        class="btn btn_info template-review-submit template-button">Next</md-button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="tab_inn" v-if="isFourthPage && athenaEnabled">
                                            <h1 id="closeUp-header" class="template-title" tabindex="-1">Ready for your close-up?</h1>
                                            <p class="box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-if="community.content && community.content.requestFormWizardPage3" v-html="community.content.requestFormWizardPage3"></p>
                                            <template v-if="loading">
                                                <div class="row">
                                                <AthenaQuestionSkeleton :is-visible="loading" />
                                            </div>
                                            </template>
                                            <template v-else>
                                            <hr class="template-hr-custom" />
                                            <div class="about-feedbackreq">
                                            <div class="template-request-review">
                                                <h2 aria-level='3' role="heading" aria-live="polite"><span>{{this.ask.first}} {{this.ask.last}}</span></h2>
                                                <tr>
                                                    <td  role="Presentation" class="fs_15 lh_111" style="font-family:'Roboto',Helvetica Neue,Helvetica,Arial,sans-serif; text-align:left; font-size:18px; color:#000001; line-height:22px;">
                                                    <span aria-live="polite" v-if="dynamicFields.college || dynamicFields.college2  || school">{{dynamicFields.college|| dynamicFields.college2 ||  school }}</span>
                                                    <span aria-live="polite" v-if="dynamicFields.year || dynamicFields.year2 || year"> ({{dynamicFields.year || dynamicFields.year2 || year }})</span>
                                                    </td>
                                                </tr>
                                                <br>
                                                <p aria-live="polite" v-if="gaiaAnswer && !isEditing" class="custom-content" v-html="sanitizeInput(gaiaFormattedAnswer)"></p>
                                                <textarea v-else type="text" v-model="gaiaAnswer" class="custom-content-2 editable-input" rows="15" aria-label="Edit your question response"></textarea>
                                            </div>
                                            <div class="row back-next-step-2 pr-25 pl-25">
                                                <div class="text-center-xs float-left" style="display: flex; gap: 30px;">
                                                                                                        <button
                                                                                                                v-if="!isEditing"
                                                                                                                :aria-label="isUndo ? 'Undo' : 'Redo'"
                                                                                                                class="btn btn_info template-review-edit template-button mb-10"
                                                                                                                :style="styleEditBtn"
                                                                                                                @click="toggleQuestionVersion()"
                                                                                                                role="button"
                                                                                                                >
                                                                                                                {{  isUndo ? 'Undo': 'Redo' }}
                                                                                                    </button>
                                                  <button
                                                        tabindex="0"
                                                        class="btn btn_info template-review-edit template-button mb-10"
                                                        :style="styleEditBtn"
                                                        @click="toggleEdit()"
                                                        role="button"
                                                        >
                                                        {{ isEditing ? 'Save' : 'Edit' }}
                                                  </button>
                                                </div>
                                                <div class="text-center-xs float-right">
                                                    <template>
                                                        <md-button v-if="!isEditing"
                                                        type="button"
                                                        aria-label="Submit your question."
                                                        :disabled="isEditing"
                                                        :aria-busy="loading"
                                                        @click="save()"
                                                        role="button"
                                                        :style="styleSubmitBtn"
                                                        class="btn btn_info template-review-submit template-button">Submit</md-button>
                                                        </template>
                                                </div>
                                            </div>
                                            <!--div class="row back-next-step-2">
                                                <div class="col-lg-6 col-md-6 col-sm-6 text-center-xs float-left">
                                                    <button class="btn btn_info template-review-edit template-button mb-10" :style="styleEditBtn" @click="goToSecond()" role="button">Back</button>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 text-center-xs float-right text-right-md">
                                                    <md-button type="button" :disabled="disabledBtn == 1 ? true : false"  :style="styleSubmitBtn"  class="btn btn_info template-review-submit template-button" @click="save()">Submit</md-button>
                                                </div>
                                            </div-->
                                            </div>
                                        </template>
                                        </div>
                                        <div class='tab_inn' v-if="isFourthPage && questionCoachEnabled">
                                            <h1 id="closeUp-header" class="template-title">Great Start</h1>
                                            <p class="box-sub-heading mb35 custom-content request-form-title-anchor-tab">We've analyzed your question and have a few suggestions to make sure you'll get a response.</p>
                                            <hr class="template-hr-custom" />
                                            <div class="about-feedbackreq">
                                                <div v-if="questionCoachScore <= 0">
                                                    <MidsizeSkeleton :is-visible="true" />
                                                </div>

                                                <div v-else class="template-request-review feedback-card" :style="{ backgroundColor: feedback.color + ' !important' }">
                                                <div class="feedback-content">
                                                    <h2 class="coach-header score-header feedback-title">
                                                        {{ feedback.text }}
                                                    </h2>
                                                    <p>{{ coachFeedback.guidance }}</p>

                                                    <!-- Checklist Display -->
                                                    <ul v-if="coachChecklist" class="feedback-checklist">
                                                        <li
                                                            v-for="(item, index) in checklistItems"
                                                            :key="item.key"
                                                            class="checklist-item"
                                                            :class="{ 'checked': item.checked, 'unchecked': !item.checked }"
                                                        >
                                                            <span class="checkbox-icon" :class="{ 'checked': item.checked }">
                                                                <svg v-if="item.checked" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <rect width="20" height="20" rx="4" fill="#10B981"/>
                                                                    <path d="M6 10L9 13L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                </svg>
                                                                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <rect width="20" height="20" rx="4" fill="#E5E7EB" stroke="#D1D5DB" stroke-width="1"/>
                                                                </svg>
                                                            </span>
                                                            <span class="checklist-text" :class="{ 'text-muted': !item.checked }">{{ item.label }}</span>
                                                        </li>
                                                    </ul>

                                                    <!-- Improvements Section -->
                                                    <div v-if="coachChecklist && !isMessageReady && coachFeedback.improvements && coachFeedback.improvements.length" class="improvements-section">
                                                        <h3 class="improvements-title">Suggestions to improve:</h3>
                                                        <ul class="improvements-list">
                                                            <li
                                                                v-for="(improvement, index) in coachFeedback.improvements"
                                                                :key="'improvement-' + index"
                                                                class="improvement-item"
                                                            >
                                                                {{ improvement }}
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                                <div class="feedback-emoji-wrapper">
                                                    <div class="score-circle" v-if="coachChecklist">
                                                        <svg width="80" height="80" viewBox="0 0 80 80">
                                                            <circle cx="40" cy="40" r="35" fill="white" stroke="#E5E7EB" stroke-width="2"/>
                                                            <text x="40" y="45" text-anchor="middle" font-size="24" font-weight="bold" fill="#1F2937">
                                                                {{ checklistCompletionCount }}/{{ checklistTotalCount }}
                                                            </text>
                                                            <text x="40" y="58" text-anchor="middle" font-size="10" fill="#6B7280">
                                                                COMPLETE
                                                            </text>
                                                        </svg>
                                                    </div>
                                                    <span class="feedback-emoji big-emoji" v-else>{{ feedback.emoji }}</span>
                                                    <span class="feedback-text-emoji">{{ feedback.text_emoji }}</span>
                                                </div>
                                            </div>
                                            <label for="coachDraftText">Edit your message below - and review changes</label>
                                                <textarea type="text" v-model="coachDraft" id="coachDraftText" class="editable-input custom-content-2" style="text-align: justify;" rows="15" aria-label="Edit your question response"></textarea>
                                                <div class="back-next-step-2"
                                                    style="display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: nowrap;">
                                                <button class="btn btn_info template-review-edit template-button"
                                                        :style="styleEditBtn"
                                                        @click="communityHasInterests ? goToThird() : goToSecond()"
                                                        role="button">
                                                    Back
                                                </button>

                                                <div style="display: flex; gap: 10px;">
                                                    <button class="btn btn_info template-review-edit template-button"
                                                        :style="styleEditBtn"
                                                        @click="questionCoach()"
                                                        role="button">
                                                    Review
                                                </button>
                                                    <md-button type="button"
                                                            :disabled="!isMessageReady"
                                                            :style="styleSubmitBtn"
                                                            class="btn btn_info template-review-submit template-button"
                                                            @click="save()">
                                                    Submit
                                                    </md-button>
                                                </div>
                                                </div>
                                        </div>
                                        </div>
                                        <div class="tab_inn" v-else-if="isFourthPage && !athenaEnabled">
                                            <h1 id="closeUp-header" aria-level="1" class="template-title">Ready for your close-up?</h1>
                                            <p class="box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-if="community.content && community.content.requestFormWizardPage3" v-html="community.content.requestFormWizardPage3"></p>
                                            <p class=" box-sub-heading mb35 custom-content request-form-title-anchor-tab" v-else >Here's what advisors will receive. Need to make a revision? Simply click "Back" and edit.</p>
                                            <hr class="template-hr-custom" />
                                            <div class="about-feedbackreq">
                                            <div class="template-request-review">
                                                <h2 aria-level="2" role="Presentation">{{this.ask.first}} {{this.ask.last}}</h2>
                                                <tr>
                                                    <td  role="Presentation" class="fs_15 lh_111" style="font-family:'Roboto',Helvetica Neue,Helvetica,Arial,sans-serif; text-align:left; font-size:18px; color:#000001; line-height:22px;">
                                                    <span v-if="dynamicFields.college || dynamicFields.college2  || school">{{dynamicFields.college|| dynamicFields.college2 ||  school }}</span>
                                                    <span v-if="dynamicFields.year || dynamicFields.year2 || year"> ({{dynamicFields.year || dynamicFields.year2 || year }})</span>
                                                    </td>
                                                </tr>
                                                <br>
                                                <h2 aria-level="2" role="Presentation">{{this.ask.subject}}</h2>
                                                <p class="font-color">{{this.ask.bio}}</p>
                                                <p class="font-color">{{this.ask.text}}</p>
                                                <p class="font-color">{{this.ask.closeNicely}}</p>
                                            </div>
                                            <div class="row back-next-step-2">
                                                <div class="col-lg-6 col-md-6 col-sm-6 text-center-xs float-left">
                                                    <button class="btn btn_info template-review-edit template-button mb-10" :style="styleEditBtn" @click="communityHasInterests ? goToThird() : goToSecond()" role="button">Back</button>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-6 text-center-xs float-right text-right-md">
                                                    <md-button type="button" :disabled="disabledBtn == 1 ? true : false"  :style="styleSubmitBtn"  class="btn btn_info template-review-submit template-button" @click="save()">Submit</md-button>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template v-if="!isBeforeRequest && !invalidMember">
                                <div class='header-text common-space-from-logo text-center unsubscribepage-thankumsg darken-request-confirmation'>
                                    <h1 class="sr-only">So what's next?</h1>
                                    <h1 id="whatsnext-header" class="box-heading thankyou-template-title" aria-hidden='true'>
                                        So what's next?
                                    </h1>
                                    <div style="color:#000001;">
                                        <div tabindex="0" v-if="community.content && community.content.requestPageThankYou" class="box-sub-heading text-left content-textleft thankyou-custom-content" @click.capture="handleThankYouResourceClick" v-html="community.content.requestPageThankYou"></div>
                                        <div style="color:#000001;" tabindex="0" v-else class="box-sub-heading text-left content-textleft thankyou-custom-content">We will now recruit the right experts to help you.</div>

                                        <div v-if="isLoadingResources" class="thankyou-loader-wrapper mt-4" aria-live="polite">
                                            <CustomThankYou :isVisible="true" />
                                        </div>

                                        <div
                                            v-if="showErrorMessage"
                                            class="thankyou-status-message mt-4"
                                            role="alert"
                                            tabindex="0"
                                            style="padding: 12px 16px; border-radius: 4px; border: 1px solid #f5c2c7; background: #f8d7da; color: #611a15;"
                                        >
                                            {{ errorMessage || 'We were unable to submit your request. Please try again.' }}
                                        </div>

                                        <div class="mt-4 text-left" v-if="showSuccessMessage">
                                            <br>
                                            <button
                                                type="button"
                                                :style="styleSubmitBtn"
                                                class="btn btn_info template-review-submit template-button"
                                                @click="askAnotherQuestion"
                                            >
                                                Ask Another Question
                                            </button>
                                        </div>
                                    </div>

                                </div>

                            </template>
                            <template v-if="!isBeforeRequest && invalidMember">
                                <div class='header-text common-space-from-logo text-left unsubscribepage-thankumsg' tabindex="0">
                                    <h1
                                        class="box-heading thankyou-template-title"
                                        role="alert"
                                        aria-live="Assertive"
                                    >
                                        Ooops. We’re really sorry
                                    </h1>
                                    <div v-if="community.content && community.content.requestPageThankYou" tabindex="0" class="box-sub-heading text-left content-textleft thankyou-custom-content" v-html="finalInvalidMemberMessage"></div>
                                </div>
                            </template>
                        </div>
                    </div>
                        <footer>
                            <ul class="list-inline text-center footer-links">
                                <li>
                                    <a :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length" tabindex="0">Learn More</a>
                                    <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
                                </li>
                                <li>
                                    <a :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length" tabindex="0">Terms Of Use [pdf]</a>
                                    <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                                </li>
                                <li>
                                    <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                                    <a href="javascript:void(0)" v-else>Opt Out</a>
                                </li>
                            </ul>
                            <div class="unsubscribe-community-logo">
                                <a :href="(community.content && community.content.landingPageURL) || 'https://www.protopia.co'" target="_blank"><img :src="footerLogoURL" :alt="'Community Logo of '+ (community && community.content && community.content.parameter4 ? community.content.parameter4 : (community && community.name) || 'Community')"></a>
                                <span class="sr-only">Protopia - Visit our site</span>
                            </div>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>


<!-- Script-->
<script>
import API, { GAIA_TIMEOUT_MS } from "../services/API";
import Member from "./Member";
import Datepicker from 'vuejs-datepicker';
import Tooltip from "./Tooltip";
import CustomSkeleton from './CustomSkeleton.vue';
import CustomThankYou from './CustomThankYouSkeleton.vue';
import AthenaQuestionSkeleton from './AthenaQuestionSkeleton.vue';
import MidsizeSkeleton from './MidsizeSkeleton.vue';
import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";
import { getGaiaQuestion, saveGaiaAnswer } from "../helpers/getGaiaQuestion";
import { sanitizeInput, sanitizeResourceDescription, sanitizeUrl, sanitizeHtmlTemplate } from '../utils/sanitizer';
import { MajorFieldsMixin } from '../helpers/majorsHelper';
import { magicWandMixin } from '../mixins/magicWandMixin';
import MagicWandExamplesPanel from './MagicWandExamplesPanel.vue';
import EventBus from '../assets/js/EventBus';
import NotFound from "./NotFound.vue";
import Config from '../utils/config';


export default {
    mixins: [MajorFieldsMixin, magicWandMixin],
    components: {
        Member,
        Datepicker,
        AthenaQuestionSkeleton,
        MidsizeSkeleton,
        Tooltip,
        CustomSkeleton,
        CustomThankYou,
        NotFound,
        MagicWandExamplesPanel
    },
    props: ["community_id", "sourceparam"],
    data() {
        return {
            captchaCalled: false,
            siteKey: Config.CAPTCHA_SITEKEY,
            api: new API(),
            ask: {},
            isEditing: false,
            school: '',
            year: '',
            gaiaAnswer: '',
            gaiaFormattedAnswer: '',
            matchedResources: [],
            communityHasInterests: false,
            enableMagicWandLF: true,
            athenaEnabled: true,
            isUndo: true,
            //Coach data
            questionCoachEnabled: false,
            questionCoachScore: 0,
            coachSessionID: "",
            coachSessionStarted: false,
            coachFeedback: "",
            coachUserInfo: "",
            coachChecklist: null,
            coachDraft: "",
            loading: false,
            community: {},
            isFirstPage: true,
            isSecondPage: false,
            isFourthPage: false,
            isThirdPage: false,
            isSubjectRequired: false,
            fullPage: true,
            max: 2000,
            remainingCount: 0,
            message: "",
            isBeforeRequest: true,
            exceedsMaxCount: false,
            configureFields: {
            firstName: {
                labelName: ''
            },
            lastName: {
                labelName: ''
            },
            emailAddress: {
                labelName: ''
            },
            subject: {
                labelName: ''
            },
            question: {
                labelName: ''
            },
            referrer: {
                labelName: ''
            },
            referrer2: {
                labelName: ''
            }
            },
            dynamicFields: {},
            newAdmin: [],
            requestForm: {
                subjectLine: 'Short summary ...',
                question: "I have a question about ..."
            },
            submitBtn: {
                colorBackd: '#9178A0',
                color: '#ffffff'
            },
            editBtn: {
                colorBackd: '#CBA8E0',
                color: '#ffffff'
            },
            memberThankYou: "",
            DatePickerFormat: "MM/dd/yyyy",
            disabledDates: {
                to: new Date(Date.now() - 8640000)
            },
            logoURL: '',
            footerLogoURL: "",
            memberRole: {},
            adviceArea: {},
            college2: {},
            major: {},
            selectedMajorTemp: '',
            // major limit UI removed
            referrer2: {},
            classYear2: {},
            channelType: "Request Form",
            memberInterestList: [],
            randomInterest: [],
            referenceInterest: [],
            selectedInterestList: [],
            askCreator: {},
            invalidMember: false,
            finalInvalidMemberMessage: "",
            minErrMsg: "Please personalize and expand.",
            showFormFlag: true,
            disabledBtn: 0,
            magicWandIcon: 'https://storage.googleapis.com/protopia/app/icons/wand.png',
            subjectCount: 0,
            bioCount: 0,
            textCount: 0,
            closeNicelyCount: 0,
            subjectMax: 100,
            bioMax: 500,
            textMax: 2000,
            closeNicelyMax: 250,
            circleId: '',
            actionPage: 'defPage',
            isSubmitting: false,
            isShow: 0,
            isLoadingResources: false,
            thankYouTemplateRaw: '',
            resourcesHtml: '',
            loadingResourcesHtml: '',
            // loadingResourcesHtml: '<div class="thankyou-resources-loading" role="status" aria-live="polite">We\'re gathering resources for you…</div>',
            showSuccessMessage: false,
            showErrorMessage: false,
            errorMessage: '',
            createdAskId: '',
            pendingResourceClicks: {},
            autoFocus: false,
            showNotFound: false
        };
    },
    watch: {
        $route: "loadData"
    },
    computed: {
        magicWandFieldConfig() {
            return [
                { field: 'subject', key: 'wizard-headlines', label: 'Short headline' },
                { field: 'bio', key: 'wizard-intros', label: 'Briefly introduce yourself' },
                { field: 'text', key: 'wizard-contents', label: 'What do you need help with?' },
                { field: 'closeNicely', key: 'wizard-closes', label: 'Close nicely' }
            ];
        },
        styleSubmitBtn() {
            return {
            'color': this.submitBtn.color,
            'background-color': this.submitBtn.colorBackd
            };
        },
        styleEditBtn() {
            return {
            'color': this.editBtn.color,
            'border-color': this.editBtn.colorBackd
            };
        },
        majorJoined() {
            const arr = Array.isArray(this.dynamicFields.major) ? this.dynamicFields.major : [];
            return arr.join(',');
        },
        isMessageReady() {
            // Enable submit when score is "good" (4+ items complete)
            if (this.coachChecklist) {
                const completionCount = Object.values(this.coachChecklist).filter(v => v === true).length;
                return completionCount >= 4;
            }
            // Fallback to score-based check
            return this.questionCoachScore >= 8;
        },
        checklistItems() {
            if (!this.coachChecklist) return [];
            return [
                { key: 'introduction', label: 'Add a greeting with brief context about why you\'re reaching out', checked: this.coachChecklist.introduction },
                { key: 'does_not_ask_for_job', label: 'Ensure you are not asking for a job directly', checked: this.coachChecklist.does_not_ask_for_job },
                { key: 'asks_not_too_many', label: 'Keep the message focused and well-structured', checked: this.coachChecklist.asks_not_too_many },
                { key: 'question_improved', label: 'Make your question specific and easy to answer', checked: this.coachChecklist.question_improved },
                { key: 'thank_you', label: 'End with a polite closing and thank you', checked: this.coachChecklist.thank_you }
            ];
        },
        checklistCompletionCount() {
            if (!this.coachChecklist) return 0;
            return Object.values(this.coachChecklist).filter(v => v === true).length;
        },
        checklistTotalCount() {
            if (!this.coachChecklist) return 0;
            return Object.keys(this.coachChecklist).length;
        },
        feedback() {
            if (this.questionCoachScore == null) {
                return { text: "", color: "transparent" };
            }
            if (this.coachChecklist) {
                if (Object.values(this.coachChecklist).every(v => v === true)) {
                    return { text: "Your message is ready to send!", emoji: "🥳", color: "#DFFAE2", text_emoji: "Looking great!" };
                }
            }
            const completionCount = this.checklistCompletionCount;
            const totalCount = this.checklistTotalCount;
            if (totalCount > 0) {
                if (completionCount <= 1) return { text: "Let's make this clearer together", emoji: "🥺", color: "#FDE7E9", text_emoji: "Let's improve!" };
                if (completionCount === 2) return { text: "Let's make a few helpful tweaks", emoji: "😉", color: "#FFF3D8", text_emoji: "Almost there!" };
                if (completionCount === 3) return { text: "Almost there! Just a couple adjustments", emoji: "😄", color: "#EAF6FF", text_emoji: "On track!" };
                if (completionCount === 4) return { text: "Nice work! One small suggestion", emoji: "🤩", color: "#E7F8EE", text_emoji: "Good!" };
            }
            const scoreMap = [
                { min: 0, max: 5.9, text: "Let's make this clearer together", emoji: "🥺", color: "#FDE7E9", text_emoji: "Let's improve!" },
                { min: 6, max: 6.9, text: "Let's make a few helpful tweaks", emoji: "😉", color: "#FFF3D8", text_emoji: "Almost there!" },
                { min: 7, max: 7.9, text: "Almost there! Just a couple adjustments", emoji: "😄", color: "#EAF6FF", text_emoji: "On track!" },
                { min: 8, max: 8.49, text: "Nice work! One small suggestion", emoji: "🤩", color: "#E7F8EE", text_emoji: "Good!" },
                { min: 8.5, max: 10, text: "Your message is ready to send!", emoji: "🥳", color: "#DFFAE2", text_emoji: "Looking great!" }
            ];
            const match = scoreMap.find(r => this.questionCoachScore >= r.min && this.questionCoachScore <= r.max);
            return match || { text: "Score out of range", color: "#e2e3e5" };
        }
    },
    mounted() {
        this.$nextTick(() => {
            const heading = document.getElementById('main-header');
            if (heading) {
                heading.setAttribute('tabindex', '-1');
                heading.focus();
            }

            setTimeout(() => {
                this.loadCaptcha();
            }, 500);
        });
    },
    // mounted() {
    //   this.$refs['firstName'].focus()
    // },
    created() {
        // setTimeout(() => {
        //     this.$refs.firstName.focus();
        // }, 1000);
        var date = new Date();
        var AddDay = date.setDate(date.getDate() + 1);
        this.disabledDates.to = new Date(AddDay - 8640000);
        this.loadData();
        const dict = {
            custom: {
                email: {
                    required: () => "Please enter your email address",
                    email: () => "Please enter a valid email address"
                },
                first: {
                    required: () => "Please enter your first name"
                },
                last: {
                    required: () => "Please enter your last name"
                },
                title: {
                    required: () => "Please enter a subject line",
                    min: () => this.minErrMsg + '(minimum 10 characters).',
                    max: () => this.minErrMsg + '(maximum 100 characters).'
                },
                message: {
                    required: () => "Please enter a question",
                    max: () => "Message may not exceed 500 characters",
                    min: () => this.minErrMsg + '(minimum 250 characters).'
                },
                college: {
                    required: () => "Please enter your college"
                },
                year: {
                    required: () => "Please enter your class year"
                },
                college2: {
                    required: () => "Please select your college"
                },
                year2: {
                    required: () => "Please select your class year"
                },
                role: {
                    required: () => "Please enter a title"
                },
                organization: {
                    required: () => "Please enter an organization"
                },
                studentId: {
                    required: () => "Please enter " + this.configureFields.studentId.labelName.toLowerCase()
                },
                dueDate: {
                    required: () => "Please enter valid date"
                },
                linkedInProfile: {
                    required: () => "Please enter linkedin profile url",
                    regex: () => "Please enter valid url"
                },
                phoneNumber: {
                    required: () => "Please enter phone number"
                },
                referrer: {
                    required: () => `Please enter about ${this.community.name} community`
                },
                referrer2: {
                    required: () => `Please select about ${this.community.name} community`
                },
                disclaimer: {
                    required: () => "Please check the above box."
                },
                memberRole: {
                    required: () => "Please select value."
                },
                adviceArea: {
                    required: () => "Please select value."
                },
                bio: {
                    required: () => "Field cannot be empty.",
                    min: () => this.minErrMsg + '(minimum 100 characters).'
                },
                closeNicely: {
                    required: () => "Field cannot be empty.",
                    min: () => this.minErrMsg + '(minimum 5 characters).'
                }
            }
        };
        // or use the instance method
        this.$validator.localize("en", dict);
    },
    methods: {
        focusHeading(id, delay = 300) {
            this.$nextTick(() => {
            setTimeout(() => {
                const heading = document.getElementById(id);
                if (heading) {
                heading.setAttribute('tabindex', '-1');
                heading.focus();
                }
            }, delay);
            });
        },
        loadCaptcha() {
            if (document.getElementById('recaptcha-script')) return;

            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.siteKey}`;
            script.async = true;
            script.defer = true;
            script.id = 'recaptcha-script';
            document.head.appendChild(script);
        },
        onMajorSelect(e) {
            const val = (this.selectedMajorTemp || '').trim();
            if (!val) return;
            if (!Array.isArray(this.dynamicFields.major)) this.dynamicFields.major = [];

            // Allow unlimited major selections
            if (!this.dynamicFields.major.includes(val)) {
                // create a new array instance to ensure reactivity fires immediately
                const next = [...this.dynamicFields.major, val].sort((a, b) => a.localeCompare(b));
                this.$set(this.dynamicFields, 'major', next);
            }
            // reset select to placeholder so it behaves like a dropdown
            this.selectedMajorTemp = '';
        },
        removeMajor(idx) {
            if (!Array.isArray(this.dynamicFields.major)) return;
            const next = this.dynamicFields.major
                .filter((_, i) => i !== idx)
                .sort((a, b) => a.localeCompare(b));
            this.$set(this.dynamicFields, 'major', next);
        },
        removeMajorByValue(value) {
            if (!Array.isArray(this.dynamicFields.major)) return;
            const next = this.dynamicFields.major
                .filter((v) => v !== value)
                .sort((a, b) => a.localeCompare(b));
            this.$set(this.dynamicFields, 'major', next);

            // Removing major; no explicit error flag to clear (flag removed)
        },
        onClick(e) {
            if (this.captchaCalled) {
                this.viewSecondPage('step-1');
                return;
            }

            e.preventDefault();
            /* eslint-disable no-undef */
            grecaptcha.enterprise.ready(async () => {
                try {
                    const token = await grecaptcha.enterprise.execute(this.siteKey, { action: 'SUBMIT' });
                    if (!token) throw new Error('Failed to generate token');
                    const response = await this.api.post("asks/recaptcha/", {token});
                    const { score } = response.data;
                    this.captchaScore = score || 0;
                    if (this.captchaScore > 0.5) {
                        this.captchaCalled = true;
                        this.viewSecondPage('step-1');
                    } else {
                        this.$toast.error("Security verification failed, reload and try again.");
                    }

                } catch (error) {
                    console.error('Error during captcha verification:', error.message);
                }
            });
            /* eslint-enable no-undef */
        },
        sanitizeInput(input) {
            return sanitizeInput(input);
        },
        sanitizeUrl(url) {
            return sanitizeUrl(url);
        },
        sanitizeHtmlTemplate(template) {
            return sanitizeHtmlTemplate(template);
        },
        sanitizeResourceDescription(description) {
            return sanitizeResourceDescription(description);
        },
        sanitizeListHTML(html) {
            // Defensive DOM-based sanitization for thank-you / resource HTML
            // Keep minimal formatting but strip scripts and inline event handlers,
            // ensure external links open safely, and sanitize hrefs.
            try {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = html || '';

                // Remove any script tags
                const scripts = tempDiv.querySelectorAll('script');
                scripts.forEach(s => s.remove());

                // Remove inline event handlers (on*) from all elements
                const all = tempDiv.querySelectorAll('*');
                all.forEach(el => {
                    // Remove attributes that start with 'on' (onclick, onerror, etc.)
                    Array.from(el.attributes).forEach(attr => {
                        if (/^on/i.test(attr.name)) {
                            el.removeAttribute(attr.name);
                        }
                    });
                });

                // Normalize anchors: sanitize href and enforce safe target/rel
                const anchors = tempDiv.querySelectorAll('a');
                anchors.forEach(a => {
                    const raw = a.getAttribute('href') || '';
                    try {
                        const safe = this.sanitizeUrl(raw);
                        a.setAttribute('href', safe);
                    } catch (e) {
                        a.removeAttribute('href');
                    }
                    a.setAttribute('target', '_blank');
                    a.setAttribute('rel', 'noopener noreferrer');
                });

                const savedResourceData = [];
                tempDiv.querySelectorAll('a[data-resource-id]').forEach((a, idx) => {
                    const markerId = `__pt_res_${idx}__`;
                    savedResourceData.push({
                        markerId,
                        resourceId: a.getAttribute('data-resource-id') || '',
                        resourceUrl: a.getAttribute('data-resource-url') || ''
                    });
                    // Use 'id' as marker since it's always in allowed list
                    a.setAttribute('id', markerId);
                });

                // Optionally run the component-level HTML sanitizer if present
                let sanitized = tempDiv.innerHTML;
                if (typeof this.sanitizeHtmlTemplate === 'function') {
                    sanitized = this.sanitizeHtmlTemplate(sanitized);
                }

                // Restore resource-tracking data attributes after DOMPurify
                if (savedResourceData.length) {
                    const resultDiv = document.createElement('div');
                    resultDiv.innerHTML = sanitized;
                    savedResourceData.forEach(saved => {
                        const a = resultDiv.querySelector(`#${saved.markerId}`);
                        if (a) {
                            if (saved.resourceId) a.setAttribute('data-resource-id', saved.resourceId);
                            if (saved.resourceUrl) a.setAttribute('data-resource-url', saved.resourceUrl);
                            a.removeAttribute('id');
                        }
                    });
                    sanitized = resultDiv.innerHTML;
                }

                return sanitized;
            } catch (err) {
                // Fallback: return an escaped plain string if something goes wrong
                const esc = (str) => String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                return esc(html || '');
            }
        },
        validateCaptcha: async function () {
            /* eslint-disable no-undef */
            const captchaResponse = grecaptcha.enterprise.getResponse();
            if (!captchaResponse) {
                this.$toast.error("Please complete the CAPTCHA below to verify you're not a robot.");
                return false;
            }

            const payload = {
                event: {
                    token: captchaResponse,
                    expectedAction: "USER_ACTION",
                    siteKey: this.siteKey
                }
            };

            const response = await this.api.post('/asks/recaptcha', payload);
            if (!response.data.success) {
                this.$toast.error("CAPTCHA verification failed. Please try again.");
                return false;
            }

            this.isCaptchaValidated = true;
            return true;

            /* eslint-enable no-undef */
        },
        loadData: async function() {
            this.memberThankYou = '';
            try {
              const startTime = Date.now();
              localStorage.setItem('community_id', this.community_id);
              let fetchDataPromise = Promise.all([
                this.api.get(`communities/${this.community_id}/community-request${this.sourceparam ? '?sourceparam=' + this.sourceparam : ""}`).then(community => {
                    this.community = community.data;
                    document.title = this.community.name + " | Get Help";
                    this.actionPage = this.community.actionPage;
                    this.communityHasInterests = this.community.content && this.community.content.configureFields && this.community.content.configureFields.interest ? this.community.content.configureFields.interest.include : false;
                    this.athenaEnabled = this.community.content && this.community.content.athenaEnabled ? this.community.content.athenaEnabled : false;
                    this.enableMagicWandLF = this.community.content && this.community.content.enableMagicWandLF !== undefined ? this.community.content.enableMagicWandLF : true;
                    this.questionCoachEnabled = this.community.content && this.community.content.questionCoachEnabledLF ? this.community.content.questionCoachEnabledLF : false;
                    // If the question coach is enabled, athena should be turned off.
                    this.athenaEnabled = this.questionCoachEnabled === true ? false : this.athenaEnabled;
                    const customSettings = this.community.customSettings;
                    if (customSettings && customSettings.faviconURL !== 'none') {
                        EventBus.$emit('change-favicon', customSettings.faviconURL);
                    }
                    this.channelType = this.community.friendlyNames && this.community.friendlyNames.requestForm ? this.community.friendlyNames.requestForm : "Request Form";
                    if (this.community.content && this.community.content.requestPageThankYou) {
                        let replaceStr = this.community.content.requestPageThankYou.replace(/\n/g, "<br />");
                        if (replaceStr.indexOf('ask.sourceparam') != -1) {
                            let re = new RegExp(`\\{\\{\\s?ask.sourceparam\\s?\\}\\}`, 'gi');
                            replaceStr = replaceStr.replace(re, sanitizeInput(this.sourceparam));
                        }
                        this.community.content.requestPageThankYou = replaceStr;
                        this.thankYouTemplateRaw = replaceStr;
                        this.resourcesHtml = '';
                        this.applyThankYouTemplate();
                    } else {
                        this.thankYouTemplateRaw = '';
                        this.resourcesHtml = '';
                    }
                    this.circleId = this.sourceparam;
                    if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.memberRole) {
                        this.memberRole = this.community.content.configureFields.memberRole;
                        if (this.memberRole.value) {
                            this.dynamicFields.memberRole = '';
                            this.memberRole.memberValue = this.memberRole.value.split(",");
                        }
                    }
                    if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.college2) {
                        this.college2 = this.community.content.configureFields.college2;
                        if (this.college2.value) {
                            this.dynamicFields.college2 = '';
                            this.college2.memberValue = this.college2.value.split(",");
                        }
                    }
                    if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.major) {
                        this.major = this.community.content.configureFields.major;
                        if (this.major.value) {
                            this.$set(this.dynamicFields, 'major', []);
                            this.major.memberValue = this.major.value.split(",");
                        }
                    }
                    if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.classYear2) {
                        this.classYear2 = this.community.content.configureFields.classYear2;
                        if (this.classYear2.value) {
                            this.dynamicFields.year2 = '';
                            this.classYear2.memberValue = this.classYear2.value.split(",");
                        }
                    }
                    if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.adviceArea) {
                        this.adviceArea = this.community.content.configureFields.adviceArea;
                        if (this.adviceArea.value) {
                            this.dynamicFields.adviceArea = '';
                            this.adviceArea.memberValue = this.adviceArea.value.split(",");
                        }
                    }

                    if (this.community.content && this.community.content.memberThankYou) {
                        this.memberThankYou = this.community.content.memberThankYou;
                    }
                    if (this.community.content && this.community.content.requestForm) {
                        this.requestForm.subjectLine = this.community.content.requestForm.subjectLine && this.community.content.requestForm.subjectLine.trim() == '' ? 'Short summary ...' : (this.community.content.requestForm.subjectLine ? this.community.content.requestForm.subjectLine.trim() : 'Short summary ...');
                        this.requestForm.question = this.community.content.requestForm.question && this.community.content.requestForm.question.trim() == '' ? "I have a question about ..." : (this.community.content.requestForm.question ? this.community.content.requestForm.question.trim() : "I have a question about ...");
                    }

                    this.submitBtn.colorBackd = customSettings.primaryBtnBgColor;
                    this.submitBtn.color = customSettings.primaryTxtColor;
                    this.editBtn.colorBackd = customSettings.secondaryBtnBgColor;
                    this.editBtn.color = customSettings.secondaryTxtColor;

                if (community.data.content && community.data.content.configureFields) {
                    this.configureFields = community.data.content.configureFields;
                }
                if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.referrer && this.community.content.configureFields.referrer.labelName) {
                    this.configureFields.referrer.labelName = this.configureFields.referrer.labelName.replace('{{community.name}}', community.data.name);
                }
                if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.referrer2) {
                    this.configureFields.referrer2.labelName = this.configureFields.referrer2.labelName.replace('{{community.name}}', community.data.name);
                    this.referrer2 = this.community.content.configureFields.referrer2;
                    if (this.referrer2.value) {
                        this.dynamicFields.referrer2 = '';
                        this.referrer2.memberValue = this.referrer2.value.split(",");
                    }
                }
                this.logoURL = getLogoURL(customSettings);
                this.footerLogoURL = getFooterURL(customSettings);
                let re = new RegExp(`\\{\\{\\s?community.email\\s?\\}\\}`, 'gi');
                this.finalInvalidMemberMessage = this.community.content.invalidMemberMessage.replace(re, (this.community.sender && this.community.sender.address) ? sanitizeInput(this.community.sender.address) : process.env.DEFAULT_EMAIL);                }),
                this.api.get(`configuration/customizations/interests?community=${this.community_id}&circle=${this.sourceparam}`).then(interests => {
                  this.referenceInterest = interests.data.values;
                })

            ]);
            await this.$helpers.redirectWhenResponseIsSlow(fetchDataPromise, startTime);
              this.isShow = 1;
              this.scrollAfterSkeleton();
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    // instead of router.replace, just flipping the flag
                    this.showNotFound = true
                    return
                }
                if (error.message === 'Timeout occurred') {
                    window.open(process.env.APP_REDIRECT_URL, '_self');
                } else {
                    console.log("Error while fetching the data", error);
                }
            }
            this.$validator.errors.clear();
            this.$validator.reset();
            setTimeout(() => {
                this.addEventListenersToFormFields();
            }, 1000);
        },
        moveToNextTooltip(event) {
            event.preventDefault();
            const nextTooltip = document.querySelector('label[for="bio"]');
            if (nextTooltip) {
                nextTooltip.focus();
            }
        },
        scrollAfterSkeleton: async function() {
            const duration = 500;
            const start = window.scrollY;
            const startTime = performance.now();
            const easeInOutQuad = (t, b, c, d) => {
              t /= d / 2;
              if (t < 1) return c / 2 * t * t + b;
              t--;
              return -c / 2 * (t * (t - 2) - 1) + b;
            };
            const animateScroll = (timestamp) => {
              const currentTime = timestamp - startTime;
              window.scrollTo(0, easeInOutQuad(currentTime, start, -start, duration));
              if (currentTime < duration) {
                requestAnimationFrame(animateScroll);
              } else {
                window.scrollTo(0, 0);
              }
            };
            requestAnimationFrame(animateScroll);
        },
        toggleQuestionVersion() {
            const temp = this.gaiaFormattedAnswer;
            this.gaiaFormattedAnswer = this.lastAnswer || this.requestText;
            this.gaiaAnswer = this.gaiaFormattedAnswer;
            this.lastAnswer = temp;
            this.ask.text = this.sanitizeInput(this.gaiaFormattedAnswer);
           this.isUndo = !this.isUndo;
        },
        toggleEdit() {
        if (this.isEditing) {
                // Validate before saving
                const trimmedText = (this.gaiaAnswer || '').trim();
                const textLength = trimmedText.length;

                if (textLength === 0 || textLength < 200) {
                    // Show error message
                    this.$toast.error('Please expand on what you need help with (minimum 200 characters).');
                    return; // Don't toggle, stay in edit mode
                }

                // If validation passes, save the changes
                this.gaiaFormattedAnswer = saveGaiaAnswer(this.gaiaAnswer);
                this.ask.text = this.sanitizeInput(this.gaiaAnswer);
                this.isEditing = false;
            } else {
                // Switch to edit mode
                this.gaiaAnswer = this.gaiaFormattedAnswer.replace(/<br\s*\/?>/gi, '\n');
                this.isEditing = true;
            }
        },
        viewSecondPage: async function(scope) {
            if (this.community.settings.siteStatus == "Inactive") {
                this.$toast.error('We are no longer accept requests.');
                return null;
            }
            this.autoFocus = true;
            this.$validator.validateAll(scope).then(async result => {
                if (result) {
                    this.tempRequestStore();
                    this.isFirstPage = false;
                    this.isSecondPage = true;
                    this.isFourthPage = false;
                    this.isSubjectRequired = false;
                } else {
                    const errorElements = document.querySelectorAll('.error');
                    if (errorElements.length > 0) {
                        let isFirstErrorFocused = false;
                        for (let errorElement of errorElements) {
                            if (errorElement.style.display !== 'none') {
                                let inputElement = errorElement.previousElementSibling;
                                while (inputElement) {
                                    if ((inputElement.tagName === 'INPUT' || inputElement.tagName === 'SELECT') && !isFirstErrorFocused) {
                                        inputElement.focus();
                                        let message = '';
                                        message = errorElement.innerText;
                                        this.errorAnnouncement(message);
                                        setTimeout(() => {
                                          this.autoFocus = false;
                                        }, 2000);
                                        isFirstErrorFocused = true;
                                        break;
                                    }
                                    inputElement = inputElement.previousElementSibling;
                                }
                            }
                        }
                    }
                }
            });
        },
        viewThirdPage: async function(scope) {
            if (this.community.settings.siteStatus == "Inactive") {
                this.$toast.error('We are no longer accept requests.');
                return null;
            }
            this.isSubjectRequired = false;
            if (!this.ask.subject) {
                this.isSubjectRequired = true;
            }
            this.$validator.validateAll(scope).then(async result => {
                if (result) {
                    this.tempRequestStore();
                    if (this.communityHasInterests) {
                        this.goToThird();
                    } else {
                        this.goToFourth();
                    }
                } else {
                    const inputErrorMessages = document.querySelectorAll('.error-message');
                    const textareaErrorMessages = document.querySelectorAll('.error-message-textarea');

                    let found = false;

                    inputErrorMessages.forEach(errorMessage => {
                        const inputElement = errorMessage.parentNode.querySelector('input.request-form-error-border');
                        if (inputElement && !found) {
                            inputElement.focus();
                            errorMessage.setAttribute('aria-live', 'polite');
                            errorMessage.setAttribute('role', 'alert');
                            found = true;
                        }
                    });

                    if (!found) {
                        textareaErrorMessages.forEach(errorMessage => {
                            const textareaElement = errorMessage.parentNode.querySelector('textarea.request-form-error-border');
                            if (textareaElement && !found) {
                                textareaElement.focus();
                                errorMessage.setAttribute('aria-live', 'polite');
                                errorMessage.setAttribute('role', 'alert');
                                found = true;
                            }
                        });
                    }
                }
            });
        },
        goToPage: async function (pageNumber, scrollPosition = 0) {
            window.scrollTo(0, scrollPosition);
            this.isFirstPage = pageNumber === 1;
            this.isSecondPage = pageNumber === 2;
            this.isThirdPage = pageNumber === 3;
            this.isFourthPage = pageNumber === 4;
            this.isSubjectRequired = false;
            if (pageNumber !== 2) {
                this.closeMagicWandExamples();
            }
        },
        goToFirst: async function () {
            await this.goToPage(1);
        },
        goToThird: async function () {
            await this.goToPage(3, 3);
            this.focusHeading('interests-header');
        },
        goToSecond: async function () {
            await this.goToPage(2);
        },
        askAnotherQuestion() {
            // Reset form state
            this.isBeforeRequest = true;
            this.showSuccessMessage = false;
            this.showErrorMessage = false;
            this.isLoadingResources = false;
            this.showFormFlag = true;
            this.createdAskId = '';
            this.pendingResourceClicks = {};

            // Clear form data
            this.ask = {};
            this.dynamicFields = {};

            // Reset validation
            this.$validator.reset();

            // Navigate to first page and focus
            this.goToFirst();
        },
        goToFourth: async function (scope) {
            this.loading = true;
            try {
                const result = await this.$validator.validateAll(scope);
                if (result) {
                    this.goToPage(4, 3);
                    this.requestText = `${this.ask.bio}\n${this.ask.text}\n${this.ask.closeNicely}`;
                    this.focusHeading('closeUp-header');
                    if (this.athenaEnabled) {
                        this.gaiaAnswer = await getGaiaQuestion(this.api, this.dynamicFields, this.community, this.channelType, this.selectedInterestList, this.ask);
                        this.ask.prompt = `${this.ask.subject}\n${this.ask.bio}\n${this.ask.text}\n${this.ask.closeNicely}`
                        this.ask.text = this.gaiaAnswer;
                        this.gaiaFormattedAnswer = this.gaiaAnswer.replace(/\n/g, '<br>');
                    } else if (this.questionCoachEnabled && !this.coachSessionStarted) {
                        try {
                            // Combine LF fields into a single draft for the coach
                            this.coachDraft = `${this.ask.bio || ''}\n\n${this.ask.text || ''}\n\n${this.ask.closeNicely || ''}`.trim();
                            const { data } = await this.api.post('coach/start-session', {
                                initial_draft: this.coachDraft,
                                user_id: "123" //TODO: Replace with users ID
                            }, { timeout: GAIA_TIMEOUT_MS });
                            const guidanceText = data.evaluation.guidance_text || "No guidance available.";
                            const strengths = data.evaluation.strengths || [];
                            const improvements = data.evaluation.improvements || [];
                            const askQualityScore = data.evaluation.ask_quality_score || 0;
                            const checklist = data.evaluation.checklist || null;
                            this.coachFeedback = { guidance: guidanceText, strengths, improvements };
                            this.questionCoachScore = askQualityScore;
                            this.coachSessionID = data.session_id || null;
                            this.coachSessionStarted = true;
                            this.coachChecklist = checklist;
                            this.coachUserInfo = this.questionCoachScore >= 8.5 ? this.coachFeedback.strengths : this.coachFeedback.improvements;
                        } catch (error) {
                            console.error("Error starting coach session:", error);
                            this.coachFeedback = "There was an issue generating feedback. Please try again.";
                            this.questionCoachScore = 0;
                            this.coachSessionID = null;
                        }
                    }
                } else {
                    this.handleErrorMessages();
                }
            } catch (err) {
                console.error(err);
            } finally {
                this.loading = false;

                // Generate tags using Gemini API
                /*let generatedTags = ['general'];
                const tagsResponse = await this.api.post('asks/generate-tags-preview', {
                    subject: this.ask.subject || 'Long Form Request',
                    text: this.ask.text
                }).catch(error => {
                    console.error("[FRONTEND] Error generando tags preview:", error);
                    return null;
                });

                if (tagsResponse && tagsResponse.data && tagsResponse.data.success && tagsResponse.data.tags) {
                    generatedTags = tagsResponse.data.tags;
                } else {
                    console.warn("[FRONTEND] No tags generated, using fallback: ['general']");
                }*/

                const resourceMessage = this.requestText || this.ask.text || '';
                // Only fills the resources block on the thank-you page, so a slow or
                // failed match must not hold up the form.
                let matchResources = null;
                try {
                    matchResources = await this.api.post(
                        `communities/${this.community_id}/match-resources`,
                        {
                            email: this.ask.email,
                            memberRole: this.dynamicFields.memberRole || null,
                            circle: this.sourceparam || '',
                            message: resourceMessage,
                            maxResources: 3
                        },
                        { timeout: GAIA_TIMEOUT_MS }
                    );
                } catch (e) {
                    console.error('Resource matching failed; continuing without resources:', e);
                }


                // Build the same HTML fragment used by fetchResources so preview and final view match visually
                try {
                    this.matchedResources = (matchResources && matchResources.data) || [];
                    const matches = (matchResources && matchResources.data) || [];
                    const resourcesHtml = this.renderResourcesHtml(matches);
                    if (!resourcesHtml) {
                        console.warn('No matched resources returned from matcher.');
                    }

                    this.resourcesHtml = resourcesHtml;
                    this.applyThankYouTemplate(resourcesHtml);
                } catch (e) {
                    console.error('Error rendering matcher resources into thank-you template', e);
                }
            }
        },
        tempRequestStore: async function(defaultReason = false) {
            this.ask.community = this.community._id;
            // Clean majors to avoid empty fields being sent
            this.cleanMajorFields();
            this.ask.dynamicFields = this.dynamicFields;
            this.ask.channelType = this.channelType;
            this.ask.sourceparam = this.sourceparam;
            this.ask.reason = defaultReason;
            this.ask.actionPage = this.actionPage;
            delete this.ask.recipients;
            await this.api.post(`asks/${this.community_id}/create-temp-request/`, this.ask).then(response => {});
        },
        deleteTempRequest: async function() {
            await this.api.post(`asks/${this.community_id}/delete-temp-request/`, this.ask).then(response => {});
        },
        async questionCoach() {
            this.questionCoachScore = 0;
            try {
                const { data } = await this.api.post('coach/coach-draft', {
                    question: this.coachDraft,
                    session_id: this.coachSessionID
                }, { timeout: GAIA_TIMEOUT_MS });
                const guidanceText = data.revised_evaluation.guidance_text || "No guidance available.";
                const strengths = data.revised_evaluation.strengths || [];
                const improvements = data.revised_evaluation.improvements || [];
                const askQualityScore = data.revised_evaluation.ask_quality_score || 0;
                const checklist = data.revised_evaluation.checklist || null;
                this.coachFeedback = { guidance: guidanceText, strengths, improvements };
                this.questionCoachScore = askQualityScore;
                this.coachChecklist = checklist;
                this.coachUserInfo = this.questionCoachScore >= 8.5 ? this.coachFeedback.strengths : this.coachFeedback.improvements;
            } catch (error) {
                console.error("Error getting coaching feedback:", error);
                this.coachFeedback = "There was an issue generating feedback. Please try again.";
                this.questionCoachScore = 0;
            }
        },
        save: async function(scope) {
            // Prevent double submission
            if (this.isSubmitting) {
                console.log("Form submission already in progress");
                return;
            }

            this.isSubmitting = true;

            if (this.community.settings.siteStatus == "Inactive") {
                this.$toast.error('We are no longer accept requests.');
                this.isSubmitting = false;
                return null;
            }
            try {
                // Sanitize all user input fields
                this.ask.text = sanitizeInput(this.ask.text);
                this.ask.subject ? this.ask.subject = this.ask.subject : this.ask.subject = 'Quick Connect';
                if (this.dynamicFields) {
                    Object.keys(this.dynamicFields).forEach(key => {
                        const val = this.dynamicFields[key];

                        if (Array.isArray(val)) {
                            this.dynamicFields[key] = val.map(v => sanitizeInput(v));
                        } else {
                            this.dynamicFields[key] = sanitizeInput(val);
                        }
                    });
                }
                // normalize major field to match backend behaviour (trim, remove empty, limit to 5)
                this.cleanMajorFields();
                await this.api
                .get(`communities/${this.community_id}/administrators`)
                .then(administrators => {
                    this.administrators = administrators.data;
                    if (administrators && administrators.data) {
                        this.administrators.map(singleAdmin => {
                        this.newAdmin.push(singleAdmin.member);
                        })
                    }
                })
                this.ask.community = this.community._id;
                this.ask.recipients = this.newAdmin;
                this.ask.dynamicFields = this.dynamicFields;
                this.ask.first = this.ask.first || this.dynamicFields.first;
                this.ask.last = this.ask.last || this.dynamicFields.last;
                this.ask.email = this.ask.email || this.dynamicFields.email;
                this.ask.channelType = this.channelType;
                this.ask.formType = 'LF';
                this.ask.sourceparam = this.sourceparam;
                this.ask.actionPage = this.actionPage;
                this.ask.source = {
                    origin: "request page",
                    sourceID: `timestamp:${Date.now()}`,
                    userID: "Web user"
                };
                if (this.selectedInterestList && this.selectedInterestList.length > 0) {
                    this.dynamicFields.interests = this.selectedInterestList;
                }
            } catch (err) {
                console.error('Error saving request:', err);
                this.$toast.error('An error occurred while saving your request. Please try again.');
            }
                if (!this.unsubscribe && !this.spamEmail && !this.invalidMember) {
                    this.deleteTempRequest();
                    if (this.memberThankYou) {
                        this.showFormFlag = false; //use this flag to hide show form
                        window.open(this.memberThankYou, '_self');
                    } else {
                        this.showFormFlag = false; //use this flag to hide show form
                        window.scrollTo(0, 0);
                        if (this.configureFields.interest && this.configureFields.interest.include == true) {
                            this.isFirstPage = false;
                            this.isSecondPage = false;
                            this.isFourthPage = false;
                            this.isThirdPage = true;

                        this.$nextTick(() => {
                            const checkboxRef = this.$refs.checkboxMainRef;
                            Object.keys(checkboxRef).forEach(function(key) {
                                const currentElement = checkboxRef[key];
                                if (currentElement.querySelector('.md-checked')) {
                                    const checkboxInput = currentElement.querySelector('input[type="checkbox"]');
                                    if (checkboxInput) {
                                        checkboxInput.checked = true;
                                        checkboxInput.dispatchEvent(new Event('change'));
                                    }
                                }
                            });
                        });

                    } else {
                        document.title = this.community.name + '| Thank You';
                        this.isBeforeRequest = false;
                    }
                }
                if (this.showFormFlag == false) {
                    this.disabledBtn = 1;
                    window.scrollTo(0, 0);
                }
                const hasPrefetchedResources = /<a\s+href=/i.test(this.resourcesHtml || '');
                if (hasPrefetchedResources && this.thankYouTemplateRaw) {
                    this.applyThankYouTemplate(this.resourcesHtml);
                }
                this.isLoadingResources = true;
                this.isBeforeRequest = false;
                this.showSuccessMessage = false;
                this.showErrorMessage = false;
                this.errorMessage = '';
                // Keep already-rendered resources visible while create-ask is pending.
                const hasRenderedResources = /<a\s+href=/i.test(this.resourcesHtml || '');
                if (!hasRenderedResources) {
                    this.prepareThankYouForLoading();
                }
                // Capture structured wizard fields before any concatenation so we can pass them.
                let __requestFieldsForNavigation = null;
                if (this.questionCoachEnabled) {
                    // When Question Coach is active, the user edited the combined draft
                    __requestFieldsForNavigation = {
                        headline: this.ask.subject || '',
                        bio: this.ask.bio || '',
                        help: this.ask.text || '',
                        closeNicely: this.ask.closeNicely || ''
                    };
                    this.ask.text = this.coachDraft;
                } else if (!this.athenaEnabled) {
                    __requestFieldsForNavigation = {
                        headline: this.ask.subject || '',
                        bio: this.ask.bio || '',
                        help: this.ask.text || '',
                        closeNicely: this.ask.closeNicely || ''
                    };
                    // Insert explicit paragraph separators so saved text renders with spacing
                    this.ask.text = `${this.ask.bio}\n\n${this.ask.text}\n\n${this.ask.closeNicely}`;
                }
                if (__requestFieldsForNavigation) {
                    try {
                        this.ask.wizardFields = __requestFieldsForNavigation;
                    } catch (e) {
                        console.error('Failed to attach wizardFields to ask payload:', e);
                    }
                }
                this.ask.text = this.ask.text.replace(/<br\s*\/?>/gi, '\n');
                try {
                this.ask.matchedResources = this.matchedResources;
                const askResponse = await this.api.post(`communities/${this.community_id}/create-ask/`, this.ask);
                const ask = askResponse;
                this.callTrackEvent(ask);
                if (ask.data.unsubscribe) {
                    this.isLoadingResources = false;
                    this.resourcesHtml = '';
                    if (this.thankYouTemplateRaw) {
                        this.applyThankYouTemplate('');
                    }
                    this.$toast.error('Your email address has been unsubscribed.');
                    this.focusHeading("whatsnext-header", 200);
                } else if (ask.data.spamEmail) {
                    this.isLoadingResources = false;
                    this.resourcesHtml = '';
                    if (this.thankYouTemplateRaw) {
                        this.applyThankYouTemplate('');
                    }
                    this.$toast.error('Your email address has been blocked.');
                    this.focusHeading("whatsnext-header", 200);
                } else if (ask.data.invalidMember || ask.data.inactiveMember) {
                    this.isLoadingResources = false;
                    this.resourcesHtml = '';
                    if (this.thankYouTemplateRaw) {
                        this.applyThankYouTemplate('');
                    }
                    this.tempRequestStore(true);
                    this.focusHeading("whatsnext-header", 200);
                } else {
                    if (this.configureFields.interest && this.configureFields.interest.include == true && ask.data.askCreator) {
                        this.ask = ask.data;
                        this.askCreator = ask.data.askCreator; // Timing when filled is slow, if Submit button in affinities is clicked before filling it causes error
                        this.disabledBtn = 0; // Added this here and a :disabled in submit button to manage button
                    } else {
                        document.title = this.community.name + ' | Thank You';
                    }
                        try {
                            const askId = ask && ask.data ? ask.data._id : '';
                            if (askId && Array.isArray(this.matchedResources) && this.matchedResources.length) {
                                this.createdAskId = askId;
                                const trackedResourcesHtml = this.renderResourcesHtml(this.matchedResources, askId);
                                if (trackedResourcesHtml) {
                                    this.resourcesHtml = trackedResourcesHtml;
                                    this.applyThankYouTemplate(trackedResourcesHtml);
                                }
                            }
                            if (askId) {
                                this.flushPendingResourceClicks(askId);
                            }
                        } catch (error) {
                            console.error("Error applying tracked resource links:", error);
                        } finally {
                    this.isLoadingResources = false;
                    if (!this.showErrorMessage) {
                        this.showSuccessMessage = true;
                            }
                            this.focusHeading("whatsnext-header", 200);
                        }
                    }
                } catch (error) {
                    console.error('Error creating ask:', error);
                    this.isLoadingResources = false;
                    this.showErrorMessage = true;
                    this.errorMessage = (error && error.response && error.response.data && error.response.data.error)
                        ? error.response.data.error
                        : 'Something went wrong while submitting your request. Please try again.';
                    this.resourcesHtml = '';
                    if (this.thankYouTemplateRaw) {
                        this.applyThankYouTemplate('');
                    }
                    this.focusHeading("whatsnext-header", 200);
                }
            } else {
                if (this.unsubscribe) {
                    this.$toast.error('Your email address has been unsubscribed.');
                } else if (this.spamEmail) {
                    this.$toast.error('Your email address has been blocked.');
                } else if (this.invalidMember) {
                    this.disabledBtn = 1;
                    this.showFormFlag = false; //use this flag to hide show form
                    this.isBeforeRequest = false;
                    this.invalidMember = true;
                    this.tempRequestStore(true);
                }
            }

            // Reset submission flag after completion or error (with delay to prevent rapid re-submission)
            setTimeout(() => {
                this.isSubmitting = false;
            }, 2000);
        },
        hasThankYouPlaceholder() {
            return typeof this.thankYouTemplateRaw === 'string' && /\{\{\s?ask\.resources\s?\}\}/i.test(this.thankYouTemplateRaw);
        },
        applyThankYouTemplate(customMarkup) {
            if (!this.community || !this.community.content) {
                return;
            }

            if (!this.thankYouTemplateRaw) {
                this.community.content.requestPageThankYou = '';
                return;
            }

            const template = this.thankYouTemplateRaw;
            const placeholderCheck = /\{\{\s?ask\.resources\s?\}\}/i;
            const hasPlaceholder = placeholderCheck.test(template);
            const replacement = typeof customMarkup === 'string' ? customMarkup : (this.resourcesHtml || '');
            const replaceRegex = /\{\{\s?ask\.resources\s?\}\}/gi;
            let renderedTemplate = hasPlaceholder ? template.replace(replaceRegex, replacement) : template;
            if (!hasPlaceholder && replacement && /<a\s+href=/i.test(replacement)) {
                const hasResourcesAlready = /class=["']pt-auto-resources-block["']/i.test(template);
                renderedTemplate = hasResourcesAlready ? template : `${template}${replacement}`;
            }

            // Sanitize the final HTML (removes scripts, inline handlers, sanitizes links)
            this.community.content.requestPageThankYou = this.sanitizeListHTML(renderedTemplate);
        },
        prepareThankYouForLoading() {
            if (!this.hasThankYouPlaceholder()) {
                return;
            }

            this.resourcesHtml = this.loadingResourcesHtml;
            this.applyThankYouTemplate();
        },
        callTrackEvent(ask) {
            this.$gtm.enable(true)
            this.$gtm.trackEvent({
                'RequestID': ask.data._id,
                'RequestSource': 'Web',
                'RequestReceived': this.$moment(ask.data.createdAt).tz("America/New_York").format('YYYYMMDD'),
                'Community': this.community.name,
                'event': 'RequestSubmitted'
            });
        },
        buildResourceTrackingUrl(resourceId, url, askId) {
            const safeUrl = this.sanitizeUrl(url || '');
            if (!askId || !resourceId || !safeUrl) {
                return safeUrl || '#';
            }

            const apiBase = (process.env.API_BASEURL || '').replace(/\/$/, '');
            const redirect = encodeURIComponent(safeUrl);
            return `${apiBase}/dashboard/resource/${encodeURIComponent(askId)}/${encodeURIComponent(resourceId)}/track-click?location=request_page&redirect=${redirect}`;
        },
        normalizeMatchedResource(match) {
            const resourceObj = match && match.resourceId && typeof match.resourceId === 'object' ? match.resourceId : null;
            const resourceId = (resourceObj && (resourceObj._id || resourceObj.id)) || (match && (match.resourceId || match._id || match.id)) || '';
            const url = this.sanitizeUrl((match && (match.url || (resourceObj && resourceObj.url))) || '');
            const name = (resourceObj && resourceObj.name) || (match && match.name) || url || '';
            const desc = this.sanitizeResourceDescription((match && (match.description || (resourceObj && resourceObj.description))) || '');

            return {
                resourceId: resourceId ? String(resourceId) : '',
                url,
                name,
                desc
            };
        },
        renderResourcesHtml(matches, askId = '') {
            if (!Array.isArray(matches) || !matches.length) {
                return '';
            }

            const communityColor = (this.community && this.community.customSettings && this.community.customSettings.primaryBtnBgColor) || '#000';
            let resourcesHtml = '<div class="pt-auto-resources-block"><div style="padding-top: 20px; padding-bottom: 20px;">Based on your question, here are some resources you can access right away: </div><ul style="list-style-type: none; padding: 0; margin: 0;">';

            matches.forEach(match => {
                const { resourceId, url, name, desc } = this.normalizeMatchedResource(match);
                if (!name && !url) return;

                const href = this.buildResourceTrackingUrl(resourceId, url, askId);
                const safeName = this.sanitizeHtmlTemplate(name);

                resourcesHtml += `\n<li style="margin-bottom: 15px; font-size: 16px; font-weight: 300; line-height: 22px;">`;
                resourcesHtml += `\n<a href="${href || '#'}" data-resource-id="${resourceId}" data-resource-url="${url}" target="_blank" rel="noopener noreferrer" style="color: ${communityColor}; font-weight: bold; text-decoration: underline;" aria-label="Learn more about ${safeName}">${safeName}</a>`;
                resourcesHtml += `\n<span style="font-size:20px; font-weight: 300; margin-left: 5px;">${desc ? '- ' + desc : ''}</span>`;
                resourcesHtml += `\n</li>`;
            });

            resourcesHtml += '\n</ul></div>';
            return resourcesHtml;
        },
        handleThankYouResourceClick(event) {
            if (!event || !event.target || typeof event.target.closest !== 'function') {
                return;
            }

            const anchor = event.target.closest('a[data-resource-id]');
            if (!anchor) {
                return;
            }

            const resourceId = anchor.getAttribute('data-resource-id') || '';
            const resourceUrl = this.sanitizeUrl(anchor.getAttribute('data-resource-url') || '');
            if (!resourceId || !resourceUrl) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            window.open(resourceUrl, '_blank', 'noopener');

            const askId = this.createdAskId || '';
            if (askId) {
                this.api.get(
                    `dashboard/resource/${encodeURIComponent(askId)}/${encodeURIComponent(resourceId)}/track-click`,
                    {
                        location: 'request_page',
                        redirect: resourceUrl,
                        skipRedirect: true
                    }
                ).catch((error) => {
                    console.error('Error tracking resource click:', error);
                });
            } else {
                if (!this.pendingResourceClicks[resourceId]) {
                    this.$set(this.pendingResourceClicks, resourceId, { count: 0, url: resourceUrl });
                }
                this.pendingResourceClicks[resourceId].count += 1;
            }
        },
        flushPendingResourceClicks(askId) {
            if (!askId || !this.pendingResourceClicks || !Object.keys(this.pendingResourceClicks).length) {
                return;
            }

            Object.keys(this.pendingResourceClicks).forEach(resourceId => {
                const pending = this.pendingResourceClicks[resourceId];
                const count = pending && pending.count ? pending.count : 0;
                const url = this.sanitizeUrl((pending && pending.url) || '');
                if (!count || !url) {
                    return;
                }

                for (let i = 0; i < count; i++) {
                    this.api.get(
                        `dashboard/resource/${encodeURIComponent(askId)}/${encodeURIComponent(resourceId)}/track-click`,
                        {
                            location: 'request_page_loader',
                            redirect: url,
                            skipRedirect: true
                        }
                    ).catch((error) => {
                        console.error('Error syncing pending resource click:', error);
                    });
                }
            });

            this.pendingResourceClicks = {};
        },
        checkAndValidate1(field) {
            // Validación defensiva para evitar errores de undefined
            if (!this.configureFields && (!this.community || !this.community.content || !this.community.content.parameter4)) {
                return '';
            }

            var validationRules = '';
            const configFields = this.configureFields || (this.community && this.community.content && this.community.content.parameter4) || {};

            if (configFields && field === 'college') {
                validationRules = configFields.college && configFields.college.require && configFields.college.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'year') {
                validationRules = configFields.classYear && configFields.classYear.require && configFields.classYear.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'college2') {
                validationRules = configFields.college2 && configFields.college2.require && configFields.college2.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'major') {
                validationRules = configFields.major && configFields.major.require && configFields.major.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'year2') {
                validationRules = configFields.classYear2 && configFields.classYear2.require && configFields.classYear2.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'role') {
                validationRules = configFields.title && configFields.title.require && configFields.title.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'organization') {
                validationRules = configFields.organization && configFields.organization.require && configFields.organization.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'studentId') {
                validationRules = configFields.studentId && configFields.studentId.require && configFields.studentId.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'dueDate') {
                validationRules = configFields.dueDate && configFields.dueDate.require && configFields.dueDate.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'linkedInProfile') {
                validationRules = configFields.linkedInProfile && configFields.linkedInProfile.require && configFields.linkedInProfile.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'phoneNumber') {
                validationRules = configFields.phoneNumber && configFields.phoneNumber.require && configFields.phoneNumber.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'referrer') {
                validationRules = configFields.referrer && configFields.referrer.require && configFields.referrer.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'referrer2') {
                validationRules = configFields.referrer2 && configFields.referrer2.require && configFields.referrer2.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'disclaimer') {
                validationRules = configFields.disclaimer && configFields.disclaimer.require && configFields.disclaimer.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'memberRole') {
                validationRules = configFields.memberRole && configFields.memberRole.require && configFields.memberRole.require === true ? 'required' : '';
                return validationRules;
            } else if (configFields && field === 'adviceArea') {
                validationRules = configFields.adviceArea && configFields.adviceArea.require && configFields.adviceArea.require === true ? 'required' : '';
                return validationRules;
            }

            // Always return a string to avoid vee-validate errors
            return '';
        },
        updateDisclaimer: function() {
            if (this.dynamicFields.disclaimer === false && this.configureFields.disclaimer.require && this.configureFields.disclaimer.require === true) {
                this.dynamicFields.disclaimer = undefined;
            }
        },
        updateProfile: async function() {
            this.isThirdPage = false;
            this.isBeforeRequest = false;
            document.title = this.community.name + '| Thank You';
            window.scrollTo(0, 0);
            if (!this.askCreator || !this.askCreator._id) {
                console.warn("updateProfile skipped: askCreator is not populated yet.");
                return;
            }
            var memberUpdateData = {
                requestId: this.ask._id,
                giveId: null,
                communityId: this.community._id,
                community: this.community.name,
                circleId: this.sourceparam,
                memberId: this.askCreator._id,
                propertyId: this.askCreator.propertyId,
                name: this.askCreator.displayName,
                email: this.askCreator.emails ? this.askCreator.emails.toString().toLowerCase() : '',
                memberObj: this.askCreator,
                callFrom: 'create-request-page',
                isAsker: true
            };
            const existingInterests = this.askCreator.interests || [];
            const newInterests = this.selectedInterestList || [];
            memberUpdateData.memberObj.interests = [...new Set([...existingInterests, ...newInterests])];
            this.isThirdPage = false;
            this.isBeforeRequest = false;
            document.title = this.community.name + ' | Thank You';
            window.scrollTo(0, 0);
            await this.api.post(`members/profile-update`, memberUpdateData).then(response => {
                this.askCreator = this.memberObj;
            });
        },
        checkMemberStatus: function() {
            this.api.post(`communities/${this.community_id}/get-member-details/`, this.ask)
                .then(async ask => {
                    this.unsubscribe = this.spamEmail = this.invalidMember = false;
                    if (ask.data.unsubscribe) {
                        this.unsubscribe = true;
                    }
                    if (ask.data.spamEmail) {
                        this.spamEmail = true;
                    }
                    if (ask.data.invalidMember || ask.data.inactiveMember) {
                        this.invalidMember = true;
                    }
                        if (ask.data.school1) {
                            this.school = ask.data.school1;
                        }
                        if (ask.data.year1) {
                            this.year = ask.data.year1;
                        }
                    if (!this.unsubscribe && !this.spamEmail && !this.invalidMember) {
                        // if (ask.data._id) {
                        //     this.memberInterestList = new Map(ask.data.interests.map(s => [s.toLowerCase(), s]));
                        //     this.memberInterestList = [...this.memberInterestList.values()];
                        // } else {
                        //     this.memberInterestList = []
                        // }
                        var memberRefrenceInterest = this.referenceInterest;
                        var mergedInterest = new Map(memberRefrenceInterest.map(s => [s.toLowerCase(), s]));

                        mergedInterest = [...mergedInterest.values()];
                        const n = process.env.RANDOM_INTEREST_COUNT;
                        var shuffled = mergedInterest.sort(function() { return 0.5 - Math.random(); });
                        this.randomInterest = shuffled.slice(0, n);
                    }
                })
        },
        countdown: function(field) {
            if (field == 'subject') {
                this.subjectCount = this.ask.subject && this.ask.subject.length ? this.ask.subject.length : 0;
            }
            if (field == 'bio') {
                this.bioCount = this.ask.bio && this.ask.bio.length ? this.ask.bio.length : 0;
            }
            if (field == 'text') {
                this.textCount = this.ask.text && this.ask.text.length ? this.ask.text.length : 0;
            }
            if (field == 'closeNicely') {
                this.closeNicelyCount = this.ask.closeNicely && this.ask.closeNicely.length ? this.ask.closeNicely.length : 0;
            }
        },
        updateAriaChecked: function(randomInterestItem) {
            const checkboxRef = this.$refs.checkboxMainRef;

            Object.keys(checkboxRef).forEach(function(key) {
                const currentElement = checkboxRef[key];
                const checkboxInput = currentElement.querySelector('input[type="checkbox"]');

                if (checkboxInput.value == randomInterestItem) {
                    // Currently it's checked. Need to make it unchecked
                    let setCheckbox = true;
                    if (currentElement.querySelector('.md-checked')) {
                        setCheckbox = false
                    }
                    checkboxInput.checked = setCheckbox;
                }
            });
        },
        handleFocusChange: function (event) {
          const textarea = event.target;
          const siblings = Array.from(textarea.parentElement.children);
          const filteredSiblings = siblings.filter(sibling =>
            sibling !== textarea && sibling.classList.contains('error-for-textarea')
          );
          let message = filteredSiblings[0].innerHTML;
          setTimeout(() => {
            this.announcementOfErrorMessage(message);
          }, 300);
        },
        errorAnnouncement(message) {
          const liveRegion = document.createElement('div');
          liveRegion.setAttribute('aria-live', 'polite');
          liveRegion.setAttribute('role', 'alert');
          liveRegion.innerText = message;
          document.body.appendChild(liveRegion);
          setTimeout(() => {
            liveRegion.remove();
          }, 1000);
        },
        announcementOfErrorMessage: function(message) {
          let focusedElement = document.activeElement;
          const siblings = Array.from(focusedElement.parentElement.children);
          const filteredSiblings = siblings.filter(sibling =>
            sibling !== focusedElement && sibling.classList.contains('error-for-textarea')
          );
          const computedStyle = window.getComputedStyle(filteredSiblings[0]);
          const displayValue = computedStyle.display;
                    if (displayValue != 'none') {
                        this.errorAnnouncement(message);
                    }
        },
        addEventListenersToFormFields: function() {
          const form = document.querySelectorAll('input, textarea, select');
          form.forEach((element) => {
            element.addEventListener('focus', (event) => {
              if (!this.autoFocus) {
                var formField = event.target;
                var message = '';
                if (formField.tagName === 'INPUT' || formField.tagName === 'SELECT') {
                  message = formField.nextElementSibling.innerText;
                } else if (formField.tagName === 'TEXTAREA') {
                  message = formField.parentNode.querySelector('.error').innerText;
                }
                this.errorAnnouncement(message);
              }
            });
          });
        }
    }
};
</script>
<style scoped>
/* Question Coach Checklist Styles */
.feedback-checklist {
    list-style: none;
    padding: 0;
    margin: 20px 0 0 0;
}

.checklist-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
}

.checklist-item:last-child {
    border-bottom: none;
}

.checkbox-icon {
    flex-shrink: 0;
    margin-top: 2px;
    transition: transform 0.2s ease;
}

.checkbox-icon.checked {
    animation: checkPop 0.3s ease;
}

@keyframes checkPop {
    0% { transform: scale(1); }
    50% { transform: scale(1.2); }
    100% { transform: scale(1); }
}

.checklist-text {
    flex: 1;
    font-family: Roboto Slab !important;
    font-style: normal !important;
    font-weight: 300 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: #000000 !important;
}

.checklist-text.text-muted {
    color: #6B7280;
    font-family: Roboto Slab !important;
    font-style: normal !important;
    font-weight: 300 !important;
}

.checklist-item.checked .checklist-text {
    color: #059669;
}

.score-circle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
}

.score-circle svg {
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.feedback-card {
    display: grid;
    grid-template-columns: 1fr 100px;
    gap: 1.5rem;
    padding: 1.5rem;
    border-radius: 12px;
    align-items: start;
    margin-bottom: 24px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
}

.feedback-emoji-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    min-width: 100px;
}

.feedback-content {
    flex: 1;
    padding-right: 24px;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    font-family: Roboto Slab !important;
    font-style: normal !important;
    font-weight: 300 !important;
    font-size: 18px !important;
    line-height: 22px !important;
    color: #000000 !important;
}

.feedback-title {
    font-family: Roboto Slab !important;
    font-style: normal !important;
    font-weight: 300 !important;
    font-size: 18px !important;
    line-height: 22px !important;
    color: #000000 !important;
    margin: 0;
}

.feedback-text-emoji {
    font-family: Roboto Slab !important;
    font-style: normal !important;
    font-weight: 300 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: #000000 !important;
    text-align: center;
}

.feedback-emoji {
    font-size: 6rem;
    line-height: 1.2;
    display: inline-block;
}

.big-emoji {
    font-size: 5rem;
    line-height: 1;
}

/* Improvements Section Styles */
.improvements-section {
    margin-top: 24px;
    padding-top: 20px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.improvements-title {
    font-family: Roboto Slab !important;
    font-style: normal !important;
    font-weight: bold !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: #000000 !important;
    margin-bottom: 16px;
}

.improvements-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.improvement-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    font-family: Roboto Slab !important;
    font-style: normal !important;
    font-weight: 300 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: #000000 !important;
}

.improvement-item:last-child {
    border-bottom: none;
}

.improvement-item::before {
    content: "→";
    color: #6B7280;
    font-weight: 600;
    flex-shrink: 0;
    margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/CommunityRequestPage.vue